import axios from "axios";
import router from "./../router";
import moment from "moment";

const APIUrl = process.env.VUE_APP_API_URL;

export default {
  getCampaignDashboards() {
    const dashboards = [
      { // PG Dach Dashboard
        name: "PG Dach Dashboard",
        campaignId: "pg-dach",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasPendingReceipt: true,
        hasWinnerList: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasRaffle: true,
        participationCounts: true,
        hasAdditionalPayment: true,
        hasGoodWill: [
          "ariel-de-24",
          "at-olympics-instantwin-24",
          "ch-olympics-instantwin-24",
          "de-olympics-instantwin-24",
          "pg_de_oly_snc"
        ],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          //base: "http://127.0.0.1:3000/api/dashboard",
          base: "https://pg-dashboard-v1.jsnp.io/api/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceiptV2",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct",
          additionalPayment: '/createAdditionalPayment'
        },
        campaigns: {
          "ariel-de-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Switzerland"],
            timeLimits: {
              start: "2024-02-01",
              end: "2024-06-15"
            }
          },
          "at-olympics-instantwin-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2024-03-28",
              end: "2024-05-12"
            }
          },
          "ch-olympics-instantwin-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Switzerland"],
            timeLimits: {
              start: "2024-04-01",
              end: "2024-06-23"
            }
          },
          "de-olympics-instantwin-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-04-22",
              end: "2024-06-02"
            }
          },
          "pg_de_oly_snc": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-04-22",
              end: "2024-06-16"
            }
          },
        }
      },
      { // PG Dach 2024 Dashboard
        name: "PG Dach 2024",
        campaignId: "pg-dach-2024",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasPendingReceipt: true,
        hasWinnerList: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasRaffle: true,
        participationCounts: true,
        hasAdditionalPayment: true,
        hasMistakesReport: true,
        hasFraudActions: true,
        hasGoodWill: [
          "ariel-cb-dach",
          "oralb-disney-de",
          "pampers-s4",
          "braun-wom-de",
          "always-aldi-25",
          "ariel-mild-scent",
          "ninjamas-dach-25",
          "ucl-braun-dach",
          "ucl-braun-nordics",
          "ucl-gillette-dach",
          "pg-uk-oldspice",
          "gillette-ucl-uk-25",
          "always-cashback-se",
          "ariel-raffle-ch-june25",
          "oldspice-concert-june-25",
          "pampers-ch-raffle-25",
          "ucl-gillette-nordics",
          "always-liners-de-25",
          "olympics-de-25",
          "olympics-at-25",
          "olympics-ch-25",
          "oldspice-uk-sep25",
          "ninjamas-dm-25",
          "pampers-club-ch",
          "always-aldi-2026",
        ],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          //base: "http://127.0.0.1:3000/api/dashboard",
          base: "https://pg-dashboard-v2.jsnp.io/api/dashboard",
          getOneReceipt: "/getOneReceiptV2",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceiptV2",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct",
          additionalPayment: '/createAdditionalPayment',
          setToFraud: '/changeStatusToFraud',
          getFraudReceipt: '/getOneReceiptFraud'
        },
        campaigns: {
          "ariel-cb-dach": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2024-08-01",
              end: "2025-03-15"
            }
          },
          "oralb-disney-de": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-07-29",
              end: "2024-09-01"
            }
          },
          "braun-wom-de": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2024-09-01",
              end: "2025-01-31"
            }
          },
          "pampers-s4": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2024-09-19",
              end: "2024-10-09"
            }
          },
          "always-aldi-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2025-01-24",
              end: "2025-01-30"
            }
          },
          "ariel-mild-scent": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2025-02-01",
              end: "2025-06-15"
            }
          },
          "ninjamas-dach-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2024-01-01",
              end: "2025-05-31"
            }
          },
          "ucl-braun-dach": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2025-07-01",
              end: "2026-01-31"
            }
          },
          "ucl-braun-nordics": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Denmark", "Norway", "Sweden"],
            timeLimits: {
              start: "2025-09-09",
              end: "2026-06-30"
            }
          },
          "ucl-gillette-dach": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2025-03-25",
              end: "2025-12-01"
            }
          },
          "pg-uk-oldspice": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["UK"],
            timeLimits: {
              start: "2025-03-17",
              end: "2025-05-02"
            }
          },
          "gillette-ucl-uk-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["UK"],
            timeLimits: {
              start: "2025-04-28",
              end: "2026-06-30"
            }
          },
          "always-cashback-se": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Sweden"],
            timeLimits: {
              start: "2025-05-12",
              end: "2025-12-31"
            }
          },
          "ariel-raffle-ch-june25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Switzerland"],
            timeLimits: {
              start: "2025-06-03",
              end: "2025-06-16"
            }
          },
          "oldspice-concert-june-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["UK"],
            timeLimits: {
              start: "2025-06-04",
              end: "2025-08-08"
            }
          },
          "pampers-ch-raffle-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Switzerland"],
            timeLimits: {
              start: "2025-06-16",
              end: "2025-07-15"
            }
          },
          "ucl-gillette-nordics": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Denmark", "Norway", "Sweden", "Finland"],
            timeLimits: {
              start: "2025-06-19",
              end: "2026-03-31"
            }
          },
          "always-liners-de-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2025-08-01",
              end: "2025-11-30"
            }
          },
          "olympics-de-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2025-12-01",
              end: "2026-02-28"
            }
          },
          "olympics-at-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2025-10-01",
              end: "2025-12-02"
            }
          },
          "olympics-ch-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Switzerland"],
            timeLimits: {
              start: "2025-10-01",
              end: "2025-11-30"
            }
          },
          "oldspice-uk-sep25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["UK"],
            timeLimits: {
              start: "2025-08-27",
              end: "2025-09-30"
            }
          },
          "ninjamas-dm-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2025-11-10",
              end: "2026-02-15"
            }
          },
          "pampers-club-ch": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Switzerland"],
            timeLimits: {
              start: "2025-12-09",
              end: "2026-02-15"
            }
          },
          "always-aldi-2026": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2025-12-15",
              end: "2026-01-22"
            }
          },
        }
      },
      //P&G
      {
        name: "P&G",
        campaignId: "pg-template",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasPendingReceipt: true,
        hasOnHoldReceipts: true,
        participationCounts: true,
        hasAdditionalPayment: true,
        hasMistakesReport: true,
        hasGoodWill: [
          "swiffer-testen",
          "always-testwoche",
          "always-3.0-testwochen",
          "al-testwoche",
          "pampers-spar",
          "hs-cashback",
          "lenor-wama",
          "lenor-un",
          "lenor-at",
          "ariel-3.0-de",
          "lenor-dm",
          "ariel-4.0-rabatt",
          "always-2.0-testwochen",
          "pampers-2.0-spar",
          "pampers-3.0-aldi",
          "pampers-rossmann",
          "always-dm",
          "lenor-pm",
          "ariel-pledge",
          "fairy-testen",
          "febreze-testen",
          "lenor-mini",
          "oldspice-testwochen",
          "oldspice-mini",
          "bad-testen",
          "pg-professional",
          "pampers-mini",
          "venus-testen-lidl",
          "wgs-at",
          "gillette-testen",
          "pgp-metro",
          "un-2.0-testen",
          "lenor-sensitiv",
          "oralb-testen",
          "pantene-testwochen",
          "oldspice-2.0-testwochen",
          "always-nightpads",
          "always-liners",
          "braun-gewinnspiel",
          "lenor-sensitiv-mini",
          "always-cotton",
          "bion3-gewinnspiel",
          "oralb-google-mini-se",
          "oralb-google-mini-no",
          "oralb-google-mini-dk",
          "oralb-google-mini-fi",
          "oralb-cashback-se",
          "oralb-cashback-no",
          "oralb-cashback-dk",
          "oralb-cashback-fi",
          "oralb-moneyback-se",
          "oralb-moneyback-no",
          "oralb-moneyback-dk",
          "oralb-moneyback-fi",
          "braun-moneyback-se",
          "braun-moneyback-no",
          "braun-moneyback-dk",
          "braun-moneyback-fi",
          "un-2.0-testen-mini",
          "pampers-wipes",
          "always-discreet-dm",
          "pampers-aldi",
          "always-discreet-july",
          "herbal-essences-uk",
          "fairy-gratis-testen",
          "oralb-testen-regeneration",
          "oldspice-sep22",
          "lenor-un-gratis",
          "oralb-gratis-testen",
          "pampers-moneyback-no",
          "pampers-moneyback-se",
          "pampers-moneyback-fi",
          "kytta-2022",
          "always-discreet-dec",
          "zzzquil-cb-2022",
          "fairy-strom",
          "always-aldi-2023",
          "oralb-gratis-testen-2023",
          "pampers-nordic-fi",
          "always-discreet-2023",
          "always-aldi-qr",
          "pg-pro-uk",
          "swiffer-2023",
          "head-shoulders-de-2023",
          "pantene-de-2023",
          "bion3-2023",
          "swiffer-wow-wochenende-raffle",
          "always-discreet-fi",
          "always-pads-dm-2023",
          "vigantolvit-cashback-de-2023",
          "de-hs-23-2",
          "de-pan-23-2",
          "de-bad-23",
          "de-ap-dm-23",
          "de-wick-23",
          "fairy-bbq-23",
          "fairy-moneyback-23",
          "de-kytta-23",
          "king-gillette-moneyback-se",
          "king-gillette-moneyback-no",
          "king-gillette-moneyback-dk",
          "king-gillette-moneyback-fi",
          "oralb-cb-23",
          "venus-cbraffle-de-2023",
          "ariel-lenor-at-23",
          "always-liners-dach-23",
          "glabs-cbraffle-dach-23",
          "lenor-sens-dach-23",
          "ppv-styling-dach-23",
          "clearblue-de-23",
          "pampers-paw-patrol",
          "fairy-strom-2",
          "fairy-winter-at",
          "always-discreet-gwp",
          "olympics-raffle",
          "gillette-venus-mbg-se",
          "gillette-venus-mbg-no",
          "gillette-venus-mbg-dk",
          "gillette-venus-mbg-fi",
          "pampers-mbg-no",
          "pampers-mbg-se",
          "pampers-mbg-fi",
          "always-discreet-dk",
          "oralb-coupon-se",
          "oralb-coupon-no",
          "oralb-coupon-dk",
          "oralb-coupon-fi",
        ],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          // base: "http://127.0.0.1:3000/api/dashboard",
          base: "https://template-v2.justsnap.eu/api/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct",
          additionalPayment: '/createAdditionalPayment'
        },
        campaigns: {
          "al-testwoche": {
            hasSpecialBase: true,
            //base: "http://127.0.0.1:3000/api/dashboard",
            base: "https://template.justsnap.eu/api/dashboard",
            priceEditable: true,
            onlyOneProduct: true,
            hasRetailer: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2020-04-01"
            }
          },
          "always-testwoche": {
            hasSpecialBase: true,
            //base: "http://127.0.0.1:3000/api/dashboard",
            base: "https://template.justsnap.eu/api/dashboard",
            priceEditable: true,
            onlyOneProduct: true,
            rossmannDiscount: true,
            hasRetailer: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2020-06-01",
              end: "2021-03-30"
            }
          },
          "always-2.0-testwochen": {
            hasSpecialBase: true,
            //base: "http://127.0.0.1:3000/api/dashboard",
            base: "https://template.justsnap.eu/api/dashboard",
            priceEditable: true,
            hasParallelCampaign: true,
            onlyOneProduct: true,
            rossmannDiscount: true,
            hasRetailer: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2020-12-01",
              end: "2021-03-31"
            }
          },
          "always-3.0-testwochen": {
            priceEditable: true,
            hasParallelCampaign: true,
            onlyOneProduct: true,
            rossmannDiscount: true,
            hasRetailer: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2020-12-01",
              end: "2021-12-31"
            }
          },
          "pampers-spar": {
            hasSpecialBase: true,
            //base: "http://127.0.0.1:3000/api/dashboard",
            base: "https://template.justsnap.eu/api/dashboard",
            priceEditable: false,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasRetailer: false,
            timeLimits: {
              start: "2020-09-07",
              end: "2020-10-31"
            }
          },
          "hs-cashback": {
            hasSpecialBase: true,
            //base: "http://127.0.0.1:3000/api/dashboard",
            base: "https://template.justsnap.eu/api/dashboard",
            priceEditable: true,
            rossmannDiscount: true,
            onlyOneProduct: false,
            hasRetailer: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2020-09-01",
              end: "2020-10-30"
            }
          },
          "lenor-wama": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            rossmannDiscount: true,
            hasInvoice: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2020-09-01",
              end: "2021-12-30"
            }
          },
          "ariel-3.0-de": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2020-10-01",
              end: "2021-01-31"
            }
          },
          "lenor-un": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            rossmannDiscount: true,
            hasInvoice: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2020-10-01",
              end: "2021-03-31"
            }
          },
          "lenor-at": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2020-10-01",
              end: "2020-11-30"
            }
          },
          "lenor-dm": {
            hasProduct: true,
            priceEditable: true,
            rossmannDiscount: false,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2020-11-01",
              end: "2021-01-31"
            }
          },
          "ariel-4.0-rabatt": {
            hasProduct: true,
            priceEditable: true,
            rossmannDiscount: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2020-11-24",
              end: "2020-12-12"
            }
          },
          "pampers-2.0-spar": {
            hasProduct: true,
            rossmannDiscount: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-01-18",
              end: "2021-02-28"
            }
          },
          "pampers-3.0-aldi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-02-19",
              end: "2021-02-27"
            }
          },
          "pampers-rossmann": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-05-24",
              end: "2021-06-13"
            }
          },
          "lenor-pm": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            rossmannDiscount: true,
            hasInvoice: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2021-04-01",
              end: "2021-09-30"
            }
          },
          "always-dm": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            rossmannDiscount: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-02-01",
              end: "2021-06-30"
            }
          },
          "fairy-testen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            rossmannDiscount: true,
            hasInvoice: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2021-04-01",
              end: "2021-07-31"
            }
          },
          "febreze-testen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            rossmannDiscount: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2021-04-01",
              end: "2021-09-30"
            }
          },
          "lenor-mini": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2020-11-01",
              end: "2021-01-31"
            }
          },
          "oldspice-testwochen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2021-04-01",
              end: "2021-04-30"
            }
          },
          "ariel-pledge": {
            noValidation: true,
            hasProduct: false,
            priceEditable: false,
            onlyOneProduct: false,
            hasRetailer: false,
            rossmannDiscount: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2020-11-01",
              end: "2022-01-31"
            }
          },
          "bad-testen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-04-01",
              end: "2021-06-30"
            }
          },
          "pg-professional": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasVatMetro: true,
            hasParallelCampaign: false,
            rossmannDiscount: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2021-05-10",
              end: "2021-07-31"
            }
          },
          "pampers-mini": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-01-18",
              end: "2021-02-28"
            }
          },
          "venus-testen-lidl": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasVatMetro: false,
            rossmannDiscount: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-06-01",
              end: "2021-06-30"
            }
          },
          "always-dm-coupon": {
            hasProduct: true,
            priceEditable: true,
            rossmannDiscount: false,
            onlyOneProduct: false,
            hasVatMetro: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-06-01",
              end: "2021-06-30"
            }
          },
          "wgs-at": {
            hasProduct: true,
            priceEditable: true,
            rossmannDiscount: false,
            onlyOneProduct: false,
            hasVatMetro: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Austria"],
            timeLimits: {
              start: "2021-06-30",
              end: "2021-08-31"
            }
          },
          "oldspice-mini": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-07-01",
              end: "2021-09-30"
            }
          },
          "pampers-4.0-aldi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-02-19",
              end: "2021-09-27"
            }
          },
          "gillette-testen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2021-09-01",
              end: "2021-09-30"
            }
          },
          "pgp-metro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: false,
            hasVatMetro: true,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-09-06",
              end: "2021-10-12"
            }
          },
          "un-2.0-testen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2021-09-20",
              end: "2022-01-31"
            }
          },
          "lenor-sensitiv": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2021-09-20",
              end: "2022-01-31"
            }
          },
          "oralb-testen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2021-09-27",
              end: "2022-01-02"
            }
          },
          "oldspice-2.0-testwochen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2021-10-01",
              end: "2021-10-31"
            }
          },
          "always-liners": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2021-10-01",
              end: "2022-03-31"
            }
          },
          "always-nightpads": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2021-10-01",
              end: "2022-03-31"
            }
          },
          "pantene-testwochen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2021-10-15",
              end: "2021-11-30"
            }
          },
          "braun-gewinnspiel": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: false,
            removeCashback: true,
            removeIbanReupload: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-11-14",
              end: "2021-11-28"
            }
          },
          "lenor-sensitiv-mini": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2021-09-20",
              end: "2022-01-31"
            }
          },
          "always-cotton": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2021-11-29",
              end: "2021-12-31"
            }
          },
          "bion3-gewinnspiel": {
            hasProduct: true,
            priceEditable: false,
            onlyOneProduct: true,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            removeIbanReupload: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2022-01-01",
              end: "2022-05-15"
            }
          },
          "oralb-cashback-se": {
            hasProduct: true,
            priceEditable: false,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Sweden"],
            timeLimits: {
              start: "2021-06-01",
              end: "2023-02-28"
            }
          },
          "oralb-cashback-no": {
            hasProduct: true,
            priceEditable: false,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Norway"],
            timeLimits: {
              start: "2021-06-01",
              end: "2023-02-28"
            }
          },
          "oralb-cashback-dk": {
            hasProduct: true,
            priceEditable: false,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Denmark"],
            timeLimits: {
              start: "2021-06-01",
              end: "2023-02-28"
            }
          },
          "oralb-cashback-fi": {
            hasProduct: true,
            priceEditable: false,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Finland"],
            timeLimits: {
              start: "2021-06-01",
              end: "2023-02-28"
            }
          },
          "oralb-google-mini-se": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Sweden"],
            timeLimits: {
              start: "2022-12-01",
              end: "2026-06-30"
            }
          },
          "oralb-google-mini-no": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Norway"],
            timeLimits: {
              start: "2022-12-01",
              end: "2026-06-30"
            }
          },
          "oralb-google-mini-dk": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Denmark"],
            timeLimits: {
              start: "2022-12-01",
              end: "2026-06-30"
            }
          },
          "oralb-google-mini-fi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Finland"],
            timeLimits: {
              start: "2022-12-01",
              end: "2026-06-30"
            }
          },
          "oralb-moneyback-se": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Sweden"],
            holdOn: true,
            hasCreateReturnForm: true,
            timeLimits: {
              start: "2021-06-30",
              end: "2026-06-30"
            },
            showPackageApproveDesign: {
              acceptPackage: true,
              declinePackage: true,
              secondDecline: true,
              secondDeclineReason: "secondtimenotfull",
              secondDeclineName: "SECOND TIME NOT FULL HARD DECLINE",
              lateDecline: true,
              lateDeclineReason: "resendLate",
              lateDeclineName: "RESEND LATE HARD DECLINE",
              declineReasons: [
                { key: "returnFormMissing", text: "Return Form" },
                { key: "productMissing", text: "Product(s) Missing" },
                {
                  key: "productNotMatching",
                  text: "Product(s) not matching with the claim"
                }
              ]
            }
          },
          "oralb-moneyback-no": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            hasCreateReturnForm: true,
            countries: ["Norway"],
            timeLimits: {
              start: "2021-06-30",
              end: "2026-06-30"
            },
            showPackageApproveDesign: {
              acceptPackage: true,
              declinePackage: true,
              secondDecline: true,
              secondDeclineReason: "secondtimenotfull",
              secondDeclineName: "SECOND TIME NOT FULL HARD DECLINE",
              lateDecline: true,
              lateDeclineReason: "resendLate",
              lateDeclineName: "RESEND LATE HARD DECLINE",
              declineReasons: [
                { key: "returnFormMissing", text: "Return Form" },
                { key: "productMissing", text: "Product(s) Missing" },
                {
                  key: "productNotMatching",
                  text: "Product(s) not matching with the claim"
                }
              ]
            }
          },
          "oralb-moneyback-dk": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            hasCreateReturnForm: true,
            countries: ["Denmark"],
            timeLimits: {
              start: "2021-06-30",
              end: "2026-06-30"
            },
            showPackageApproveDesign: {
              acceptPackage: true,
              declinePackage: true,
              secondDecline: true,
              secondDeclineReason: "secondtimenotfull",
              secondDeclineName: "SECOND TIME NOT FULL HARD DECLINE",
              lateDecline: true,
              lateDeclineReason: "resendLate",
              lateDeclineName: "RESEND LATE HARD DECLINE",
              declineReasons: [
                { key: "returnFormMissing", text: "Return Form" },
                { key: "productMissing", text: "Product(s) Missing" },
                {
                  key: "productNotMatching",
                  text: "Product(s) not matching with the claim"
                }
              ]
            }
          },
          "oralb-moneyback-fi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            hasCreateReturnForm: true,
            countries: ["Finland"],
            timeLimits: {
              start: "2021-06-30",
              end: "2026-06-30"
            },
            showPackageApproveDesign: {
              acceptPackage: true,
              declinePackage: true,
              secondDecline: true,
              secondDeclineReason: "secondtimenotfull",
              secondDeclineName: "SECOND TIME NOT FULL HARD DECLINE",
              lateDecline: true,
              lateDeclineReason: "resendLate",
              lateDeclineName: "RESEND LATE HARD DECLINE",
              declineReasons: [
                { key: "returnFormMissing", text: "Return Form" },
                { key: "productMissing", text: "Product(s) Missing" },
                {
                  key: "productNotMatching",
                  text: "Product(s) not matching with the claim"
                }
              ]
            }
          },
          "braun-moneyback-se": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            hasCreateReturnForm: true,
            countries: ["Sweden"],
            timeLimits: {
              start: "2021-10-01",
              end: "2026-06-30"
            },
            showPackageApproveDesign: {
              acceptPackage: true,
              declinePackage: true,
              secondDecline: true,
              secondDeclineReason: "secondtimenotfull",
              secondDeclineName: "SECOND TIME NOT FULL HARD DECLINE",
              lateDecline: true,
              lateDeclineReason: "resendLate",
              lateDeclineName: "RESEND LATE HARD DECLINE",
              declineReasons: [
                { key: "returnFormMissing", text: "Return Form" },
                { key: "productMissing", text: "Product(s) Missing" },
                {
                  key: "productNotMatching",
                  text: "Product(s) not matching with the claim"
                }
              ]
            }
          },
          "braun-moneyback-no": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            hasCreateReturnForm: true,
            countries: ["Norway"],
            timeLimits: {
              start: "2021-10-01",
              end: "2026-06-30"
            },
            showPackageApproveDesign: {
              acceptPackage: true,
              declinePackage: true,
              secondDecline: true,
              secondDeclineReason: "secondtimenotfull",
              secondDeclineName: "SECOND TIME NOT FULL HARD DECLINE",
              lateDecline: true,
              lateDeclineReason: "resendLate",
              lateDeclineName: "RESEND LATE HARD DECLINE",
              declineReasons: [
                { key: "returnFormMissing", text: "Return Form" },
                { key: "productMissing", text: "Product(s) Missing" },
                {
                  key: "productNotMatching",
                  text: "Product(s) not matching with the claim"
                }
              ]
            }
          },
          "braun-moneyback-dk": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            hasCreateReturnForm: true,
            countries: ["Denmark"],
            timeLimits: {
              start: "2021-10-01",
              end: "2026-06-30"
            },
            showPackageApproveDesign: {
              acceptPackage: true,
              declinePackage: true,
              secondDecline: true,
              secondDeclineReason: "secondtimenotfull",
              secondDeclineName: "SECOND TIME NOT FULL HARD DECLINE",
              lateDecline: true,
              lateDeclineReason: "resendLate",
              lateDeclineName: "RESEND LATE HARD DECLINE",
              declineReasons: [
                { key: "returnFormMissing", text: "Return Form" },
                { key: "productMissing", text: "Product(s) Missing" },
                {
                  key: "productNotMatching",
                  text: "Product(s) not matching with the claim"
                }
              ]
            }
          },
          "braun-moneyback-fi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            hasCreateReturnForm: true,
            countries: ["Finland"],
            timeLimits: {
              start: "2021-10-01",
              end: "2026-06-30"
            },
            showPackageApproveDesign: {
              acceptPackage: true,
              declinePackage: true,
              secondDecline: true,
              secondDeclineReason: "secondtimenotfull",
              secondDeclineName: "SECOND TIME NOT FULL HARD DECLINE",
              lateDecline: true,
              lateDeclineReason: "resendLate",
              lateDeclineName: "RESEND LATE HARD DECLINE",
              declineReasons: [
                { key: "returnFormMissing", text: "Return Form" },
                { key: "productMissing", text: "Product(s) Missing" },
                {
                  key: "productNotMatching",
                  text: "Product(s) not matching with the claim"
                }
              ]
            }
          },
          "un-2.0-testen-mini": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2022-01-01",
              end: "2022-06-31"
            }
          },
          "pampers-wipes": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2022-04-01",
              end: "2022-06-30"
            }
          },
          "always-discreet-dm": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2022-04-01",
              end: "2022-05-31"
            }
          },
          "swiffer-testen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2022-04-01",
              end: "2022-07-31"
            }
          },
          "pampers-aldi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2022-05-16",
              end: "2022-05-23"
            }
          },
          "always-discreet-july": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2022-07-01",
              end: "2022-12-31"
            }
          },
          "herbal-essences-uk": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["UK"],
            timeLimits: {
              start: "2022-05-16",
              end: "2023-10-17"
            }
          },
          "herbal-essences-ie": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Ireland"],
            timeLimits: {
              start: "2022-12-30",
              end: "2023-02-15"
            }
          },
          "pg-nordics-fairy": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: true,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: true,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Sweden"],
            timeLimits: {
              start: "2022-07-25",
              end: "2022-09-10"
            }
          },
          "pg-nordics-gillette": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: true,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Sweden"],
            timeLimits: {
              start: "2022-07-25",
              end: "2022-09-10"
            }
          },
          "fairy-gratis-testen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            rossmannDiscount: true,
            hasInvoice: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2022-08-01",
              end: "2022-10-31"
            }
          },
          "oralb-testen-regeneration": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: true,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2022-08-01",
              end: "2022-12-31"
            }
          },
          "oldspice-sep22": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2022-09-01",
              end: "2022-09-30"
            }
          },
          "lenor-un-gratis": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            rossmannDiscount: true,
            hasInvoice: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2022-10-31", // 2022-11-01
              end: "2023-03-15"
            }
          },
          "oralb-gratis-testen": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: true,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2022-10-31", // 2022-11-01
              end: "2023-01-31"
            }
          },
          "pampers-moneyback-se": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Sweden"],
            timeLimits: {
              start: "2022-11-30",
              end: "2023-06-30"
            },
            showPackageApproveDesign: {
              acceptPackage: true,
              declinePackage: true,
              secondDecline: true,
              secondDeclineReason: "secondtimenotfull",
              secondDeclineName: "SECOND TIME NOT FULL HARD DECLINE",
              lateDecline: true,
              lateDeclineReason: "resendLate",
              lateDeclineName: "RESEND LATE HARD DECLINE",
              declineReasons: [
                { key: "returnFormMissing", text: "Return Form" },
                { key: "productMissing", text: "Product(s) Missing" },
                {
                  key: "productNotMatching",
                  text: "Product(s) not matching with the claim"
                }
              ]
            }
          },
          "pampers-moneyback-no": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Norway"],
            timeLimits: {
              start: "2022-11-30",
              end: "2023-06-30"
            },
            showPackageApproveDesign: {
              acceptPackage: true,
              declinePackage: true,
              secondDecline: true,
              secondDeclineReason: "secondtimenotfull",
              secondDeclineName: "SECOND TIME NOT FULL HARD DECLINE",
              lateDecline: true,
              lateDeclineReason: "resendLate",
              lateDeclineName: "RESEND LATE HARD DECLINE",
              declineReasons: [
                { key: "returnFormMissing", text: "Return Form" },
                { key: "productMissing", text: "Product(s) Missing" },
                {
                  key: "productNotMatching",
                  text: "Product(s) not matching with the claim"
                }
              ]
            }
          },
          "pampers-moneyback-fi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Finland"],
            timeLimits: {
              start: "2022-11-30",
              end: "2023-06-30"
            },
            showPackageApproveDesign: {
              acceptPackage: true,
              declinePackage: true,
              secondDecline: true,
              secondDeclineReason: "secondtimenotfull",
              secondDeclineName: "SECOND TIME NOT FULL HARD DECLINE",
              lateDecline: true,
              lateDeclineReason: "resendLate",
              lateDeclineName: "RESEND LATE HARD DECLINE",
              declineReasons: [
                { key: "returnFormMissing", text: "Return Form" },
                { key: "productMissing", text: "Product(s) Missing" },
                {
                  key: "productNotMatching",
                  text: "Product(s) not matching with the claim"
                }
              ]
            }
          },
          "kytta-2022": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2022-12-02",
              end: "2023-01-29"
            }
          },
          "always-discreet-dec": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2022-12-03",
              end: "2022-12-17"
            }
          },
          "always-flex-protect": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2023-01-01",
              end: "2023-08-31"
            }
          },
          "zzzquil-cb-2022": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            removeProductIfNotProductList: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2022-12-15",
              end: "2023-01-31"
            }
          },
          "fairy-strom": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            removeProductIfNotProductList: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2022-12-30", //Real date is : 2023-01-08
              end: "2023-03-05"
            }
          },
          "always-aldi-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2023-01-13",
              end: "2023-01-20"
            }
          },
          "oralb-gratis-testen-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: true,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-01-19", // 2023-02-01
              end: "2023-03-31"
            }
          },
          "pampers-nordic-fi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Finland"],
            timeLimits: {
              start: "2023-02-01",
              end: "2024-12-31"
            }
          },
          "always-discreet-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: true,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2023-02-01",
              end: "2023-12-31"
            }
          },
          "always-aldi-qr": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: true,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-02-13",
              end: "2023-03-31"
            }
          },
          "pg-pro-uk": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["uk"],
            timeLimits: {
              start: "2023-02-15",
              end: "2023-05-15"
            }
          },
          "swiffer-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2023-02-17",
              end: "2023-04-30"
            }
          },
          "head-shoulders-de-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-03-14",
              end: "2023-04-30"
            }
          },
          "pantene-de-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-03-14",
              end: "2023-04-30"
            }
          },
          "bion3-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasRetailer: false,
            hasInvoice: false,
            rossmannDiscount: true,
            removeProductIfNotProductList: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-04-01",
              end: "2023-06-30"
            }
          },
          "swiffer-wow-wochenende-raffle": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-04-01",
              end: "2023-07-01"
            }
          },
          "always-pads-dm-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-04-01",
              end: "2023-06-30"
            }
          },
          "always-discreet-fi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Finland"],
            timeLimits: {
              start: "2023-04-14",
              end: "2025-12-31"
            }
          },
          "vigantolvit-cashback-de-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-05-15",
              end: "2023-06-30"
            }
          },
          "de-hs-23-2": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-05-12",
              end: "2023-06-12"
            }
          },
          "de-pan-23-2": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-05-12",
              end: "2023-06-12"
            }
          },
          "de-bad-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-05-29",
              end: "2023-07-31"
            }
          },
          "de-ap-dm-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-06-01",
              end: "2023-06-30"
            }
          },
          "de-wick-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-06-05",
              end: "2023-06-30"
            }
          },
          "fairy-bbq-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2023-06-15",
              end: "2023-11-15"
            }
          },
          "fairy-moneyback-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2023-07-01",
              end: "2023-10-15"
            }
          },
          "de-kytta-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            removeProductIfNotProductList: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2023-06-15",
              end: "2023-09-30"
            }
          },
          "king-gillette-moneyback-se": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Sweden"],
            timeLimits: {
              start: "2023-06-28",
              end: "2025-06-30"
            },
          },
          "king-gillette-moneyback-no": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Norway"],
            timeLimits: {
              start: "2023-06-28",
              end: "2025-06-30"
            },
          },
          "king-gillette-moneyback-dk": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Denmark"],
            timeLimits: {
              start: "2023-06-28",
              end: "2025-06-30"
            },
          },
          "king-gillette-moneyback-fi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Finland"],
            timeLimits: {
              start: "2023-06-28",
              end: "2025-06-30"
            }
          },
          "oralb-cb-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            removeProductIfNotProductList: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2023-08-01",
              end: "2023-12-31"
            }
          },
          "venus-cbraffle-de-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            removeProductIfNotProductList: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-08-14",
              end: "2023-08-27"
            }
          },
          "ariel-lenor-at-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            removeProductIfNotProductList: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2023-08-15",
              end: "2023-11-30"
            }
          },
          "always-liners-dach-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            removeProductIfNotProductList: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2023-08-15",
              end: "2024-02-29"
            }
          },
          "glabs-cbraffle-dach-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            removeProductIfNotProductList: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-09-01",
              end: "2023-09-14"
            }
          },
          "lenor-sens-dach-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            rossmannDiscount: true,
            hasInvoice: false,
            hasProductFELink: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2023-09-15",
              end: "2024-02-15"
            }
          },
          "ppv-styling-dach-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2023-10-17",
              end: "2023-12-31"
            }
          },
          "clearblue-de-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2024-01-02",
              end: "2024-03-31"
            }
          },
          "pampers-paw-patrol": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-11-03",
              end: "2023-11-10"
            }
          },
          "fairy-strom-2": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2023-12-01",
              end: "2024-03-15"
            }
          },
          "fairy-winter-at": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2023-12-01",
              end: "2024-04-30"
            }
          },
          "always-discreet-gwp": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-12-01",
              end: "2023-12-31"
            }
          },
          "olympics-raffle": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-02-01",
              end: "2024-05-15"
            }
          },
          "gillette-venus-mbg-se": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Sweden"],
            timeLimits: {
              start: "2024-01-01",
              end: "2026-06-30"
            },
          },
          "gillette-venus-mbg-no": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Norway"],
            timeLimits: {
              start: "2024-01-01",
              end: "2026-06-30"
            },
          },
          "gillette-venus-mbg-dk": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Denmark"],
            timeLimits: {
              start: "2024-01-01",
              end: "2026-06-30"
            },
          },
          "gillette-venus-mbg-fi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Finland"],
            timeLimits: {
              start: "2024-01-01",
              end: "2026-06-30"
            }
          },
          "pampers-mbg-se": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Sweden"],
            timeLimits: {
              start: "2024-01-01",
              end: "2024-06-30"
            },
          },
          "pampers-mbg-no": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Norway"],
            timeLimits: {
              start: "2024-01-01",
              end: "2024-06-30"
            },
          },
          "pampers-mbg-fi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Finland"],
            timeLimits: {
              start: "2024-01-01",
              end: "2024-06-30"
            },
          },
          "always-discreet-dk": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            holdOn: true,
            countries: ["Denmark"],
            timeLimits: {
              start: "2024-01-01",
              end: "2025-12-31"
            }
          },
          "oralb-coupon-se": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Sweden"],
            timeLimits: {
              start: "2024-04-08",
              end: "2026-06-30"
            },
          },
          "oralb-coupon-no": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Norway"],
            timeLimits: {
              start: "2024-04-08",
              end: "2026-06-30"
            },
          },
          "oralb-coupon-dk": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Denmark"],
            timeLimits: {
              start: "2024-04-08",
              end: "2026-06-30"
            },
          },
          "oralb-coupon-fi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Finland"],
            timeLimits: {
              start: "2024-04-08",
              end: "2026-06-30"
            }
          },
        }
      },
      //P&G ROMANIA
      {
        name: "P&G Romania",
        campaignId: "pg-ro",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasWinnerList: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasPendingReceipt: true,
        hasRaffle: true,
        participationCounts: true,
        hasMistakesReport: true,
        showRppData: true,
        hasGoodWill: [
          "pg-30-ro-2.0",
          "pg-youtil-ro",
          "pg-charity-ro",
          "pampers-auchan-ro",
          "pg-30-ro",
          "pg-charity-2.0",
          "pg-auchan-ro",
          "lenor-un-2.0",
          "fairy-carrefour",
          "gillette-20-ro",
          "oralb-2022-ro",
          "lenor-beads-cb",
          "30-carrefour-2022",
          "mrproper-2022",
          "swiffer-2022",
          "fairy-ro-23",
          "swiffer-ro-2023",
          "always-ro-2023",
          "alwaysdiscreet-ro-2023",
          "mbci-ro-2023",
          "haircare-ro-2023",
          "brigadahs-ro-2023",
          "venuscontest-ro-2023",
          "pantenemegahair-ro-2023",
          "lenorcontest-ro-2023",
          "oldspicecontest-ro-2023",
          "alwaysplatinumcontest-ro-2023",
          "arielldpcontest-ro-2023",
          "btsauchan-ro-2023",
          "fixodentcontest-ro-2023",
          "geolaila-ro-2023",
          "homecarecontest-ro-2023",
          "oldspice-megaimage-raffle-2023",
          "dentaldays-ro-2023",
          "btscarrefour-ro-2023",
          "swifferlidl-ro-2023",
          "lenorldp-ro-2023",
          "lenorlidl-ro-2023",
          "mbcicora-ro-2023",
          "alwayslidl-ro-2023",
          "oldspicelidl-ro-2023",
          "pgcarrefour-ro-2023",
          "swifferkit-ro-2023",
          "oldspice-carrefour-ro-2023",
          "brauncashback-ro-2023",
          "pgclean-ro-2023",
          "zzzquil-ro-2023",
          "pgauchan-ro-2023",
          "pampersldp-ro-2023",
          "mrproper-ro-2023",
          "pglidl-ro-2023",
          "oralcarecarrefour-ro-2023",
          "arielldp-ro-2023",
          "pamperspenny-ro-2023",
          "pggiftingcarrefour-ro-2023",
          "fairymrproper-ro-2023",
          "pamperslidl-ro-2023",
          "arielldp-ro-2024",
          "ariel-lenor-ro-2024",
          "fairymrproper-ro-2024",
          "oldspicecarrefour-ro-2024",
          "pampersldp-ro-2024",
          "beautylidl-ro-2024",
          "zzzquilolympics-ro-2024",
          "oldspicegaming-ro-2024",
          "venus-ro-2024",
          "arielfairyldp-ro-2024",
          "swiffercarrefour-ro-2024",
          "lidlcleaning-ro-2024",
          "alwaysdiscreet-ro-2024",
          "oldspicemusic-ro-2024",
          "fixodent-ro-2024",
          "lenorcarrefour-ro-2024",
          "oldspiceauchan-ro-2024",
          "arielldpjune-ro-2024",
          "csrcarrefour-ro-2024",
          "mrproper-ro-2024",
          "hslidl-ro-2024",
          "oralbcb-ro-2024",
          "pgunicarm-ro-2024",
          "arielanniversary-ro-2024",
          "venussummer-ro-2024",
          "pamperssummer-ro-2024",
          "mrproper-ro-2024-mihai",
          "mrproper-ro-2024-elvis",
          "mrproper-ro-2024-levi",
          "fixodentcatena-ro-2024",
          "lenorrcw-ro-2024",
          "oldspicesummer-ro-2024",
          "fixodentpharma-ro-2024",
          "arielauchan-ro-2024",
          "hstt-ro-2024",
          "oldspicett-ro-2024",
          "pamperstt-ro-2024",
          "always30-ro-2024",
          "lenorbeads-ro-2024",
          "hsoctober-ro-2024",
          "arielmegaimage-ro-2024",
          "pantenemi-ro-2024",
          "mrpropercb-ro-2024",
          "oldspiceannabella-ro-2024",
          "swifferlidl-ro-2024",
          "pampersldp-ro-2025",
          "oralbdentist-ro-2025",
          "alwaysauchan-ro-2025",
          "beautytt-ro-2025",
          "pgcashback-ro-2025",
          "braunucl-ro-2025",
          "zzzquil-ro-2025",
          "pantenett-ro-2025",
          "zzzquilcatena-ro-2025",
          "fairyhdwtt-ro-2025",
          "oldspiceannabella-ro-2025",
          "panteneclub-ro-2025",
          "oldspicecocos-ro-2025",
          "gillettevenus-ro-2025",
          "oralbio2crf-ro-2025",
          "oldspicelidl-ro-2025",
          "lidlcleaning-ro-2025",
          "pampersibr-ro-2025",
          "fairyhdwldp-ro-2025",
          "hdwproperlidl-ro-2025",
          "swifferlidl-ro-2025",
          "homecareclub-ro-2025",
          "pampersariel-ro-2025",
          "venuskaufland-ro-2025",
          "hskaufland-ro-2025",
          "oralbcb-ro-2025",
          "gillettenational-ro-2025",
          "gilletteuclcarrefour-ro-2025",
          "gilletteuclkaufland-ro-2025",
          "gilletteucllidl-ro-2025",
        ],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          // base: "http://127.0.0.1:3000/api/dashboard",
          base: "https://pg-romania.justsnap.eu/api/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct"
        },
        campaigns: {
          "pg-youtil-ro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2021-03-01",
              end: "2021-04-30"
            }
          },
          "pg-charity-ro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2021-05-06",
              end: "2021-06-30"
            }
          },
          "pampers-auchan-ro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2021-06-01",
              end: "2021-06-30"
            }
          },
          "pg-30-ro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2021-09-15",
              end: "2021-10-15"
            }
          },
          "pg-charity-2.0": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2021-10-15",
              end: "2021-12-01"
            }
          },
          "pg-auchan-ro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2021-10-27",
              end: "2022-01-31"
            }
          },
          "pg-30-ro-2.0": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2022-03-01",
              end: "2022-04-06"
            }
          },
          "lenor-un-2.0": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2022-03-31",
              end: "2022-04-30"
            }
          },
          "fairy-carrefour": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2022-07-20",
              end: "2022-08-27"
            }
          },
          "gillette-20-ro": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2022-09-01",
              end: "2023-03-31"
            }
          },
          "oralb-2022-ro": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2022-09-01", // 2022-10-01
              end: "2022-11-10"
            }
          },
          "lenor-beads-cb": {
            hasProduct: false,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2022-10-17",
              end: "2022-11-30"
            }
          },
          "30-carrefour-2022": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2022-11-03",
              end: "2022-12-16"
            }
          },
          "mrproper-2022": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2022-11-15",
              end: "2023-01-15"
            }
          },
          "swiffer-2022": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2022-11-15",
              end: "2023-01-15"
            }
          },
          "fairy-ro-23": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-02-13",
              end: "2023-04-15"
            }
          },
          "swiffer-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-03-10",
              end: "2023-06-20"
            }
          },
          "always-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-04-26",
              end: "2023-06-30"
            }
          },
          "alwaysdiscreet-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-05-06",
              end: "2023-06-30"
            }
          },
          "mbci-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-05-29",
              end: "2023-06-30"
            }
          },
          "haircare-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-05-29",
              end: "2023-07-06"
            }
          },
          "brigadahs-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-07-13",
              end: "2023-10-05"
            }
          },
          "venuscontest-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-07-20",
              end: "2023-10-15"
            }
          },
          "pantenemegahair-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-07-20",
              end: "2023-08-16"
            }
          },
          "lenorcontest-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-07-28",
              end: "2023-09-15"
            }
          },
          "oldspicecontest-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-07-28",
              end: "2023-08-31"
            }
          },
          "alwaysplatinumcontest-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-07-28",
              end: "2023-10-15"
            }
          },
          "arielldpcontest-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-07-28",
              end: "2023-08-31"
            }
          },
          "btsauchan-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-07-28",
              end: "2023-09-19"
            }
          },
          "fixodentcontest-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-08-02",
              end: "2023-09-07"
            }
          },
          "geolaila-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-08-03",
              end: "2023-08-12"
            }
          },
          "homecarecontest-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-08-10",
              end: "2023-10-30"
            }
          },
          "oldspice-megaimage-raffle-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-08-15",
              end: "2023-09-13"
            }
          },
          "dentaldays-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-08-22",
              end: "2023-09-20"
            }
          },
          "btscarrefour-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-08-22",
              end: "2023-09-19"
            }
          },
          "swifferlidl-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-01",
              end: "2023-09-24"
            }
          },
          "lenorldp-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-01",
              end: "2023-09-30"
            }
          },
          "lenorlidl-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-08",
              end: "2023-09-17"
            }
          },
          "mbcicora-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-15",
              end: "2023-10-16"
            }
          },
          "alwayslidl-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-15",
              end: "2023-10-22"
            }
          },
          "oldspicelidl-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-20",
              end: "2023-10-22"
            }
          },
          "pgcarrefour-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-21",
              end: "2023-10-20"
            }
          },
          "swifferkit-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-26",
              end: "2023-12-31"
            }
          },
          "brauncashback-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-26",
              end: "2023-10-26"
            }
          },
          "oldspice-carrefour-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-26",
              end: "2023-11-30"
            }
          },
          "pgclean-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-28",
              end: "2023-12-31"
            }
          },
          "zzzquil-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-09-28",
              end: "2023-11-30"
            }
          },
          "pgauchan-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-10-02",
              end: "2023-10-24"
            }
          },
          "pampersldp-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-10-02",
              end: "2023-10-31"
            }
          },
          "mrproper-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-10-10",
              end: "2023-12-15"
            }
          },
          "pglidl-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-10-20",
              end: "2023-11-30"
            }
          },
          "oralcarecarrefour-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-10-23",
              end: "2023-11-14"
            }
          },
          "arielldp-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-10-26",
              end: "2023-11-30"
            }
          },
          "pamperspenny-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-11-20",
              end: "2024-01-10"
            }
          },
          "pggiftingcarrefour-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-11-20",
              end: "2024-01-09"
            }
          },
          "fairymrproper-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-12-05",
              end: "2023-12-31"
            }
          },
          "pamperslidl-ro-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-12-16",
              end: "2024-01-18"
            }
          },
          "arielldp-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2023-12-20",
              end: "2024-01-31"
            }
          },
          "ariel-lenor-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-01-08",
              end: "2024-02-13"
            }
          },
          "fairymrproper-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-01-20",
              end: "2024-02-29"
            }
          },
          "oldspicecarrefour-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-01-26",
              end: "2024-02-29"
            }
          },
          "pampersldp-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-02-20",
              end: "2024-03-31"
            }
          },
          "beautylidl-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-02-20",
              end: "2024-03-31"
            }
          },
          "zzzquilolympics-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-03-20",
              end: "2024-05-31"
            }
          },
          "oldspicegaming-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-03-20",
              end: "2024-04-30"
            }
          },
          "venus-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-03-29",
              end: "2024-06-30"
            }
          },
          "arielfairyldp-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-03-29",
              end: "2024-04-30"
            }
          },
          "swiffercarrefour-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-03-29",
              end: "2024-04-30"
            }
          },
          "lidlcleaning-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-04-05",
              end: "2024-05-15"
            }
          },
          "alwaysdiscreet-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-04-05",
              end: "2024-05-15"
            }
          },
          "oldspicemusic-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-04-26",
              end: "2024-06-15"
            }
          },
          "fixodent-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-04-26",
              end: "2024-05-31"
            }
          },
          "lenorcarrefour-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-05-15",
              end: "2024-07-15"
            }
          },
          "oldspiceauchan-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-05-29",
              end: "2024-06-11"
            }
          },
          "arielldpjune-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-05-28",
              end: "2024-06-30"
            }
          },
          "csrcarrefour-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-06-04",
              end: "2024-06-20"
            }
          },
          "mrproper-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-06-10",
              end: "2024-07-31"
            }
          },
          "hslidl-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-06-14",
              end: "2024-06-23"
            }
          },
          "oralbcb-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-07-22",
              end: "2025-06-30"
            }
          },
          "pgunicarm-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-06-24",
              end: "2024-07-31"
            }
          },
          "arielanniversary-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-07-02",
              end: "2024-09-30"
            }
          },
          "venussummer-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-07-11",
              end: "2024-09-30"
            }
          },
          "pamperssummer-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-07-18",
              end: "2024-10-06"
            }
          },
          "mrproper-ro-2024-mihai": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-06-10",
              end: "2024-07-31"
            }
          },
          "mrproper-ro-2024-levi": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-06-10",
              end: "2024-07-31"
            }
          },
          "mrproper-ro-2024-elvis": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-06-10",
              end: "2024-07-31"
            }
          },
          "fixodentcatena-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-07-24",
              end: "2024-09-30"
            }
          },
          "lenorrcw-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-07-26",
              end: "2024-09-30"
            }
          },
          "oldspicesummer-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-07-29",
              end: "2024-09-30"
            }
          },
          "fixodentpharma-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-08-13",
              end: "2024-09-20"
            }
          },
          "arielauchan-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-08-20",
              end: "2024-10-10"
            }
          },
          "hstt-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-08-15",
              end: "2024-09-30"
            }
          },
          "oldspicett-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-08-27",
              end: "2024-09-30"
            }
          },
          "pamperstt-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-09-12",
              end: "2024-11-15"
            }
          },
          "always30-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-10-01",
              end: "2024-11-30"
            }
          },
          "lenorbeads-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-09-25",
              end: "2024-12-15"
            }
          },
          "hsoctober-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-09-26",
              end: "2024-10-31"
            }
          },
          "arielmegaimage-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-09-30",
              end: "2024-11-06"
            }
          },
          "pantenemi-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-11-05",
              end: "2024-12-04"
            }
          },
          "mrpropercb-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-11-11",
              end: "2025-02-15"
            }
          },
          "oldspiceannabella-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-11-14",
              end: "2025-01-20"
            }
          },
          "swifferlidl-ro-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-11-26",
              end: "2024-12-15"
            }
          },
          "pampersldp-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2024-12-18",
              end: "2025-01-31"
            }
          },
          "oralbdentist-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-01-13",
              end: "2026-06-30"
            }
          },
          "alwaysauchan-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-01-30",
              end: "2025-02-28"
            }
          },
          "beautytt-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-02-11",
              end: "2025-03-15"
            }
          },
          "pgcashback-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-02-14",
              end: "2025-04-07"
            }
          },
          "braunucl-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-02-25",
              end: "2025-04-06"
            }
          },
          "zzzquil-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-02-26",
              end: "2025-04-30"
            }
          },
          "pantenett-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-02-27",
              end: "2025-03-31"
            }
          },
          "zzzquilcatena-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-03-25",
              end: "2025-04-30"
            }
          },
          "fairyhdwtt-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-04-03",
              end: "2025-05-31"
            },
          },
          "oldspiceannabella-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-04-03",
              end: "2025-05-15"
            }
          },
          "panteneclub-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-04-09",
              end: "2026-01-09"
            }
          },
          "oldspicecocos-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-04-03",
              end: "2025-05-15"
            }
          },
          "gillettevenus-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-04-09",
              end: "2025-05-15"
            }
          },
          "oralbio2crf-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-04-11",
              end: "2025-05-31"
            }
          },
          "oldspicelidl-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-04-15",
              end: "2025-06-18"
            }
          },
          "lidlcleaning-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-04-18",
              end: "2025-05-25"
            }
          },
          "pampersibr-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-04-25",
              end: "2025-05-31"
            }
          },
          "fairyhdwldp-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-04-28",
              end: "2025-05-31"
            },
          },
          "hdwproperlidl-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-05-07",
              end: "2025-06-30"
            }
          },
          "swifferlidl-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-05-08",
              end: "2025-07-13"
            }
          },
          "homecareclub-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-05-20",
              end: "2025-12-31"
            }
          },
          "pampersariel-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-05-25",
              end: "2025-06-17"
            }
          },
          "venuskaufland-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-05-28",
              end: "2025-07-01"
            }
          },
          "hskaufland-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-06-02",
              end: "2025-06-12"
            }
          },
          "oralbcb-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-07-08",
              end: "2025-12-31"
            }
          },
          "gillettenational-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-09-24",
              end: "2025-12-30"
            }
          },
          "gilletteuclcarrefour-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-10-10",
              end: "2026-01-15"
            }
          },
          "gilletteuclkaufland-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-10-10",
              end: "2026-01-15"
            }
          },
          "gilletteucllidl-ro-2025": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2025-10-21",
              end: "2026-01-31"
            }
          },
        },
      },
      //P&G TURKEY
      {
        name: "P&G TURKEY",
        campaignId: "pg-turkey",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasGoodWill: [
          "carrefour-30-cb",
          "firsat-yaninda",
          "altin-firsat",
          "altin-firsat-2.0",
          "altin-firsat-migros",
          "rengarenkBahar",
          "bahar-ozel",
          "altin-firsat-olimpiyat",
          "altin-firsat-orkid",
          "altin-firsat-orkid-2",
          "firsat-yaninda-pg35yil",
          "firsat-yaninda-pg35yil-2",
          "oralb-dishekimleri-io",
          "gilette-firsat-yaninda-2023",
          "fairy-firsat-yaninda-2023",
          "orkid-platinum-fy-2023",
          "oral-b-firsat-yaninda-2023",
          "carefour-firsat-yaninda",
          "pg-umutla-parise",
          "firsatyaninda-gillette-cashback",
          "oralb-io-cashback",
          "fixodent-whatsapp-cashback",
          "pg-professional-cashback",
          "oralb-dishekimleri-dt"
        ],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          // base: "http://192.168.1.109:3000/api/dashboard",
          base: "https://pg-turkey.justsnap.eu/api/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct"
        },
        campaigns: {
          "firsat-yaninda": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2021-03-01",
              end: "2021-08-31"
            }
          },
          "firsat-yaninda-olimpiyat": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2021-03-01",
              end: "2021-08-31"
            }
          },
          "ariel-arcelik": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2021-10-15",
              end: "2021-12-15"
            }
          },
          "altin-firsat": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2021-10-01",
              end: "2022-01-31"
            }
          },
          "he-watsons": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2021-11-01",
              end: "2021-12-31"
            }
          },
          "altin-firsat-2.0": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2021-10-01",
              end: "2022-05-16"
            }
          },
          "carrefour-30-cb": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2022-03-01",
              end: "2022-04-30"
            }
          },
          "altin-firsat-migros": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2022-03-11",
              end: "2022-04-30"
            }
          },
          rengarenkBahar: {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2022-04-01",
              end: "2022-06-13"
            }
          },
          "bahar-ozel": {
            hasProduct: false,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2022-05-05",
              end: "2022-05-31"
            }
          },
          "altin-firsat-olimpiyat": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2022-04-19",
              end: "2022-08-15"
            }
          },
          // "altin-firsat-orkid": {
          //   hasProduct: true,
          //   priceEditable: true,
          //   onlyOneProduct: false,
          //   hasParallelCampaign: true,
          //   hasRetailer: false,
          //   hasInvoice: false,
          //   countries: ["Turkey"],
          //   timeLimits: {
          //     start: "2022-08-01",
          //     end: "2022-09-30"
          //   }
          // },
          "altin-firsat-orkid-2": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2022-11-09",
              end: "2023-04-30"
            }
          },
          "firsat-yaninda-pg35yil": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2022-09-01",
              end: "2023-03-31"
            }
          },
          "firsat-yaninda-pg35yil-2": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2023-01-05",
              end: "2023-03-31"
            }
          },
          "oralb-dishekimleri-io": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2022-12-01",
              end: "2025-06-30"
            }
          },
          "gilette-firsat-yaninda-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2023-02-01",
              end: "2023-05-31"
            }
          },
          "fairy-firsat-yaninda-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2023-05-02",
              end: "2023-05-31"
            }
          },
          "orkid-platinum-fy-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2023-03-22",
              end: "2023-06-15"
            }
          },
          "oral-b-firsat-yaninda-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2023-03-29",
              end: "2023-06-01"
            }
          },
          "carefour-firsat-yaninda": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2023-03-08",//real date is 2023-03-15
              end: "2023-06-30"
            }
          },
          "pg-umutla-parise": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2023-08-03",
              end: "2023-12-31"
            }
          },
          "firsatyaninda-gillette-cashback": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2023-08-31",
              end: "2024-07-01"
            }
          },
          "oralb-io-cashback": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2024-05-09",
              end: "2024-09-01"
            }
          },
          "fixodent-whatsapp-cashback": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2023-10-15",
              end: "2024-06-30"
            }
          },
          "pg-professional-cashback": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2024-01-25",
              end: "2024-05-15"
            }
          },
          "oralb-dishekimleri-dt": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Turkey"],
            timeLimits: {
              start: "2022-12-01",
              end: "2025-06-30"
            }
          }
        }
      },
      { // P&G Azerbaijan (uses same endpoints as P&G Turkey)
        name: "P&G AZERBAIJAN",
        campaignId: "pg-turkey",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasGoodWill: [
          "aze-lotery-pg",
          "aze-lottery-pg2"
        ],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          // base: "http://192.168.1.109:3000/api/dashboard",
          base: "https://pg-turkey.justsnap.eu/api/dashboard",
          getOneReceipt: "/getOneReceiptAzerbaijan",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatisticsAzerbaijan",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct"
        },
        campaigns: {
          "aze-lotery-pg": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            hasFiscalId: true,
            countries: ["Azerbaijan"],
            timeLimits: {
              start: "2024-06-01",
              end: "2024-07-07"
            }
          },
          "aze-lottery-pg2": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            hasFiscalId: true,
            countries: ["Azerbaijan"],
            timeLimits: {
              start: "2024-06-01",
              end: "2024-09-15"
            }
          },
        }
      },
      // P&G Greece
      {
        name: "P&G GREECE",
        campaignId: "pg-greece",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasWinnerList: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasPendingReceipt: true,
        hasRaffle: true,
        participationCounts: true,
        hasMistakesReport: true,
        showRppData: true,
        hasGoodWill: [
          "pampers-gr-1",
          "national-cashback-gr",
          "ariel-sklavenitis-2022",
          "zzzquil-gr-2023",
          "braun-gr-mb2023",
          "homecare-gr-cb-2023",
          "always-gr-cb-2023",
          "gillette-gr-mb-2023",
          "oralbkids-gr-2023",
          "lenor-gr-mb-2023",
          "arielsklavenitis-gr-2023",
          "arielolympics-gr-2024",
          "lenor-gr-mb-2024",
          "oralbcb-gr-2024",
          "arielanniversary-gr-2024",
          "alwaysanniversary-gr-2024",
          "clearbluecb-gr-2025",
          "oralbcontest-gr-2025",
          "gilletteucl-gr-2025",
          "gilletteucllidl-gr-2025",
        ],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          //base: "http://127.0.0.1:3000/api/greece/dashboard",
          base: "https://pg-romania.justsnap.eu/api/greece/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct"
        },
        campaigns: {
          "pampers-gr-1": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: false,
            hasInvoice: false,
            downloadVoucher: true,
            countries: ["Greece"],
            timeLimits: {
              start: "2022-09-19",
              end: "2023-09-30"
            }
          },
          "national-cashback-gr": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            mandatoryPostCode: true,
            noCashbackEdit: true,
            countries: ["Greece"],
            timeLimits: {
              start: "2022-10-20",
              end: "2023-01-20"
            }
          },
          "ariel-sklavenitis-2022": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            mandatoryPostCode: true,
            postCodeLabel: "Retailer Mobile Number",
            noCashbackEdit: true,
            countries: ["Greece"],
            timeLimits: {
              start: "2022-11-10",
              end: "2022-11-23"
            }
          },
          "zzzquil-gr-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Greece"],
            timeLimits: {
              start: "2023-03-07",
              end: "2023-04-30"
            }
          },
          "braun-gr-mb2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            downloadVoucher: true,
            countries: ["Greece"],
            timeLimits: {
              start: "2024-07-01",
              end: "2026-06-30"
            }
          },
          "homecare-gr-cb-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            countries: ["Greece"],
            timeLimits: {
              start: "2023-04-26",
              end: "2023-06-30"
            }
          },
          "always-gr-cb-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            countries: ["Greece"],
            timeLimits: {
              start: "2023-04-26", //05-01
              end: "2023-08-31"
            }
          },
          "gillette-gr-mb-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Greece"],
            timeLimits: {
              start: "2024-07-01",
              end: "2025-06-30"
            }
          },
          "oralbkids-gr-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Greece"],
            timeLimits: {
              start: "2023-08-17",
              end: "2023-09-30"
            }
          },
          "lenor-gr-mb-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Greece"],
            timeLimits: {
              start: "2023-09-22",
              end: "2023-12-31"
            }
          },
          "arielsklavenitis-gr-2023": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Greece"],
            timeLimits: {
              start: "2023-11-01",
              end: "2023-11-29"
            }
          },
          "arielolympics-gr-2024": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Greece"],
            timeLimits: {
              start: "2024-05-10",
              end: "2024-07-15"
            }
          },
          "lenor-gr-mb-2024": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Greece"],
            timeLimits: {
              start: "2024-06-24",
              end: "2024-12-31"
            }
          },
          "oralbcb-gr-2024": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            countries: ["Greece"],
            timeLimits: {
              start: "2024-06-24",
              end: "2026-06-30"
            }
          },
          "arielanniversary-gr-2024": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Greece"],
            timeLimits: {
              start: "2024-08-28",
              end: "2024-11-30"
            }
          },
          "alwaysanniversary-gr-2024": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Greece"],
            timeLimits: {
              start: "2024-09-17",
              end: "2024-12-31"
            }
          },
          "clearbluecb-gr-2025": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            countries: ["Greece"],
            timeLimits: {
              start: "2025-05-14",
              end: "2025-09-30"
            }
          },
          "oralbcontest-gr-2025": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            countries: ["Greece"],
            timeLimits: {
              start: "2025-08-12",
              end: "2025-10-07"
            }
          },
          "gilletteucl-gr-2025": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            countries: ["Greece"],
            timeLimits: {
              start: "2025-10-01",
              end: "2025-12-19"
            }
          },
          "gilletteucllidl-gr-2025": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: true,
            hasRetailer: true,
            countries: ["Greece"],
            timeLimits: {
              start: "2025-11-06",
              end: "2025-12-10"
            }
          },
        }
      },
      // P&G Serbia
      {
        name: "P&G Serbia",
        campaignId: "pg-serbia",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasWinnerList: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasPendingReceipt: true,
        hasRaffle: true,
        participationCounts: true,
        hasMistakesReport: true,
        hasGoodWill: [
          "mbci-rs-23",
          "old-spice-rs",
          "stamps-project-rs",
          "memory-game-rs",
          "gillette-memory-august",
          "fairy-moneyback-rs",
          "pampers-moneyback-rs",
          "mbci-dm-rs-2023",
          "pampers-loyalty-rs",
          "always-memory-rs-2023",
          "mbci-rs-oct-23",
          "pampers-mercator-rs",
          "pampers-mercator-loyalty-rs",
          "oldspice-rs-23",
          "always-platinum-cashback-rs",
          "mbci-rs-may-24",
          "naturella-mercator-july-24",
          "oralb-cashback-rs-25",
          "ariel-memory-rs-24",
          "gillette-memory-rs-24",
          "naturella-lilly-sep-24",
          "pampers-creative-sep-rs",
          "mbci-dm-memory-rs",
          "naturella-memory-oct24-rs",
          "cashback-rs-oct-24",
          "oralb-memory-oct24-rs",
          "mbci-creative-rs-24",
          "fairy-mercator-rs24",
          "pampers-rsmercator-wave2",
          "oldspice-memory-dec24rs",
          "always-cashback-rs24-dec",
          "gifting-rs-dec24",
          "lenor-gamification-rs-25",
          "hs-cashback-rs-25",
          "mbci-rs-may-25",
          "oralb-game-july-25",
          "lidl-creative-aug-25",
          "oralb-memory-sep25",
          "always-sep25-rs",
          "mbci-rs-oct25",
          "gillette-uefa-rs25",
          "ariel-lenor-creative25",
          "gillette-lidl-rs25",
        ],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          // base: "http://127.0.0.1:3000/api/serbia/dashboard",
          base: "https://pg-romania.justsnap.eu/api/serbia/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct"
        },
        campaigns: {
          "mbci-rs-23": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-02-24",
              end: "2023-04-30"
            }
          },
          "old-spice-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-06-14",
              end: "2023-08-01"
            }
          },
          "stamps-project-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-06-14",
              end: "2023-08-01"
            }
          },
          "memory-game-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-06-14",
              end: "2023-08-01"
            }
          },
          "gillette-memory-august": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-08-10",
              end: "2023-09-20"
            }
          },
          "fairy-moneyback-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-08-24",
              end: "2024-02-29"
            }
          },
          "pampers-moneyback-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-08-24",
              end: "2025-06-30"
            }
          },
          "mbci-dm-rs-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-08-25",
              end: "2023-09-30"
            }
          },
          "pampers-loyalty-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-08-25",
              end: "2023-12-31"
            }
          },
          "always-memory-rs-2023": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-08-25",
              end: "2023-09-30"
            }
          },
          "mbci-rs-oct-23": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-09-20",
              end: "2023-11-30"
            }
          },
          "pampers-mercator-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-09-20",
              end: "2023-10-28"
            }
          },
          "pampers-mercator-loyalty-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-10-26",
              end: "2024-01-09"
            }
          },
          "oldspice-rs-23": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2023-11-17",
              end: "2023-12-23"
            }
          },
          "always-platinum-cashback-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-01-10",
              end: "2024-03-31"
            }
          },
          "mbci-rs-may-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-04-20",
              end: "2024-06-30"
            }
          },
          "naturella-mercator-july-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-07-03",
              end: "2024-08-03"
            }
          },
          "oralb-cashback-rs-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-08-01",
              end: "2025-06-30"
            }
          },
          "ariel-memory-rs-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-08-01",
              end: "2024-08-31"
            }
          },
          "gillette-memory-rs-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-08-26",
              end: "2024-10-02"
            }
          },
          "naturella-lilly-sep-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-08-28",
              end: "2024-09-30"
            }
          },
          "pampers-creative-sep-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-08-28",
              end: "2024-10-27"
            }
          },
          "mbci-dm-memory-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-08-28",
              end: "2024-09-30"
            }
          },
          "naturella-memory-oct24-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-09-25",
              end: "2024-10-31"
            }
          },
          "cashback-rs-oct-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-09-26",
              end: "2024-11-30"
            }
          },
          "oralb-memory-oct24-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-09-26",
              end: "2024-10-30"
            }
          },
          "mbci-creative-rs-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-09-26",
              end: "2024-10-26"
            }
          },
          "fairy-mercator-rs24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-10-17",
              end: "2024-11-23"
            }
          },
          "pampers-rsmercator-wave2": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-10-17",
              end: "2025-01-08"
            }
          },
          "always-cashback-rs24-dec": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-11-25",
              end: "2025-01-31"
            }
          },
          "gifting-rs-dec24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-11-25",
              end: "2025-01-31"
            }
          },
          "oldspice-memory-dec24rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2024-11-25",
              end: "2024-12-31"
            }
          },
          "lenor-gamification-rs-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Serbia"],
            timeLimits: {
              start: "2025-01-30",
              end: "2025-02-28"
            }
          },
          "hs-cashback-rs-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Serbia"],
            timeLimits: {
              start: "2025-03-26",
              end: "2025-04-30"
            }
          },
          "mbci-rs-may-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Serbia"],
            timeLimits: {
              start: "2025-04-21",
              end: "2025-06-30"
            }
          },
          "oralb-game-july-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Serbia"],
            timeLimits: {
              start: "2025-07-04",
              end: "2025-08-31"
            }
          },
          "lidl-creative-aug-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Serbia"],
            timeLimits: {
              start: "2025-07-28",
              end: "2025-10-31"
            }
          },
          "oralb-memory-sep25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Serbia"],
            timeLimits: {
              start: "2025-08-12",
              end: "2025-09-30"
            }
          },
          "always-sep25-rs": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Serbia"],
            timeLimits: {
              start: "2025-08-13",
              end: "2025-09-30"
            }
          },
          "mbci-rs-oct25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Serbia"],
            timeLimits: {
              start: "2025-09-22",
              end: "2025-11-30"
            }
          },
          "gillette-uefa-rs25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Serbia"],
            timeLimits: {
              start: "2025-10-20",
              end: "2025-12-31"
            }
          },
          "ariel-lenor-creative25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Serbia"],
            timeLimits: {
              start: "2025-10-28",
              end: "2025-12-01"
            }
          },
          "gillette-lidl-rs25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Serbia"],
            timeLimits: {
              start: "2025-11-14",
              end: "2026-01-21"
            }
          },
        }
      },
      // P&G Bulgaria
      {
        name: "P&G Bulgaria",
        campaignId: "pg-bulgaria",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasWinnerList: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasPendingReceipt: true,
        hasRaffle: true,
        participationCounts: true,
        hasMistakesReport: true,
        hasGoodWill: [
          "always-raffle-bg",
          "fairy-raffle-bg",
          "fairy-april-raffle-bg",
          "pampers-raffle-bg",
          "pampers-dm-bg",
          "homecare-kaufland-bg",
          "swiffer-june-bg",
          "pampers-june-bg",
          "discreet-june-bg",
          "venus-june-bg",
          "always-lilly-bg",
          "ariel-lenor-bg",
          "venus-gillette-august",
          "always-kaufland-august",
          "fairy-moneyback-bg",
          "always-cashback-2023-bg",
          "gillette-charcoal-kaufland",
          "fairy-october-bg",
          "lenor-moneyback-bg",
          "ariel-loyalty-bg",
          "gillette-charcoal-november-bg",
          "dropbydrop-loyalty-bg",
          "oralb-november-kaufland-bg",
          "gifting-dm-bg-dec",
          "mbci-kaufland-2024-bg",
          "ariel-raffle-bg-2024",
          "swiffer-moneyback-bg",
          "lilly-loyalty-bg",
          "safeguard-raffle-bg-2024",
          "gillette-lidl-bg",
          "lenor-may-bg-2024",
          "hs-bg-2024",
          "oralb-dm-raffle-bg",
          "mbci-kaufland-raffle-bg",
          "ariel-wama-raffle-bg",
          "lidl-mbci-raffle-bg",
          "gillette-loyalty-lilly-bg",
          "kaufland-grocery-raffle-bg",
          "pampers-loyalty-billa-bg-24",
          "always-bg-raffle-2024",
          "lenor-moneyback-bg-24",
          "hs-raffle-july-2024-bg",
          "metro-beauty-bg-24",
          "oralb-cashback-25-bg",
          "always-lilly-august-bg",
          "pampers-loyalty-kaufland-aug-24",
          "fabric-care-aug-24",
          "mbci-kaufland-cms-bg",
          "oldspice-aug-24-bg",
          "oralb-sep-dm-24",
          "oralb-raffle-sep-24",
          "billa-autumn-bg-24",
          "always-cashback-bg-24",
          "lidl-babycare-bg24",
          "pantene-kaufland-bg24",
          "oralb-kaufland-bg24",
          "gifting-bg-nov24",
          "ariel-rafflebg-nov24",
          "gillette-lillybg-nov24",
          "gillette-kauflandbg-nov24",
          "always-kaufland-bg-25",
          "ariel-wama-bg-25",
          "lidl-fabric-bg-25",
          "fairy-loyalty-bg-25",
          "hs-cashback-bg-25",
          "gillette-lidl-bg-25",
          "mbci-bg-april-24",
          "loyalty-june-25",
          "oralb-dm-june-25",
          "gillette-kaufland-june-25",
          "pantene-june-2025-bg",
          "oralb-kaufland-june-25",
          "oralb-lilly-june-25",
          "oldspice-bg-june-25",
          "pampers-bg-june-25",
          "pampers-care-bg-25",
          "fairy-june-bg-25",
          "lenor-july-bg-25",
          "pampers-new-july-25",
          "haircare-july-bg-25",
          "always-kaufland-bg-july",
          "mbci-billa-bg-25",
          "always-lilly-august-bg25",
          "venus-bg-aug25",
          "always-lidl-aug25-bg",
          "ariel-lenor-aug25",
          "fabric-aug-bg25",
          "autumn-cleaning-bg25",
          "old-spice-july-bg25",
          "bts-bg-raffle-25",
          "always-cashback-bg25",
          "billa-sep-bg25",
          "mbci-lidl-sep25",
          "mbci-kaufland-sep25",
          "mbci-bg-oct-25",
          "pampers-lidl-oct25",
          "gillette-ucl-bg25",
          "homecare-raffle-nov25",
          "kaufland-fabric-nov25",
          "billa-nov-bg25",
          "pantene-dec-bg25",
          "always-dm-dec25",
          "gillette-lidl-bg25",
          "gifting-dec-bg25",
          "always-lilly-bg26",
          "lenor-dec25-bg",
        ],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          // base: "http://127.0.0.1:3000/api/bulgaria/dashboard",
          base: "https://pg-romania.justsnap.eu/api/bulgaria/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct"
        },
        campaigns: {
          "always-raffle-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-03-03",
              end: "2023-04-03"
            }
          },
          "fairy-raffle-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-03-07",
              end: "2023-04-09"
            }
          },
          "fairy-april-raffle-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-04-15",
              end: "2023-05-31"
            }
          },
          "pampers-raffle-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-04-15",
              end: "2023-05-31"
            }
          },
          "pampers-dm-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-05-06",
              end: "2023-06-07"
            }
          },
          "homecare-kaufland-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-05-06",
              end: "2023-06-11"
            }
          },
          "swiffer-june-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-05-15",
              end: "2023-06-30"
            }
          },
          "pampers-june-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-05-15",
              end: "2023-06-30"
            }
          },
          "discreet-june-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-05-15",
              end: "2023-06-30"
            }
          },
          "venus-june-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-05-25",
              end: "2023-06-30"
            }
          },
          "ariel-lenor-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-06-27",
              end: "2023-08-02"
            }
          },
          "always-lilly-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-06-27",
              end: "2023-07-31"
            }
          },
          "venus-gillette-august": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-07-15",
              end: "2023-08-31"
            }
          },
          "always-kaufland-august": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-08-02",
              end: "2023-09-03"
            }
          },
          "fairy-moneyback-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-08-24",
              end: "2024-02-29"
            }
          },
          "always-cashback-2023-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-09-20",
              end: "2023-11-30"
            }
          },
          "gillette-charcoal-kaufland": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-09-20",
              end: "2023-10-31"
            }
          },
          "fairy-october-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-09-20",
              end: "2023-10-31"
            }
          },
          "lenor-moneyback-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-09-20",
              end: "2023-12-31"
            }
          },
          "ariel-loyalty-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-09-20",
              end: "2023-11-26"
            }
          },
          "gillette-charcoal-november-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-10-26",
              end: "2023-11-30"
            }
          },
          "dropbydrop-loyalty-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-11-01",
              end: "2023-12-31"
            }
          },
          "oralb-november-kaufland-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-11-09",
              end: "2023-12-31"
            }
          },
          "gifting-dm-bg-dec": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2023-12-05",
              end: "2024-01-03"
            }
          },
          "mbci-kaufland-2024-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-01-08",
              end: "2024-03-31"
            }
          },
          "ariel-raffle-bg-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-01-10",
              end: "2024-03-31"
            }
          },
          "swiffer-moneyback-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            downloadVoucher: true,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-01-10",
              end: "2024-04-30"
            }
          },
          "lilly-loyalty-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-01-10",
              end: "2024-03-31"
            }
          },
          "safeguard-raffle-bg-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-02-08",
              end: "2024-03-15"
            }
          },
          "gillette-lidl-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-04-18",
              end: "2024-05-22"
            }
          },
          "lenor-may-bg-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-04-22",
              end: "2024-06-30"
            }
          },
          "hs-bg-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-04-22",
              end: "2024-05-31"
            }
          },
          "oralb-dm-raffle-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-05-20",
              end: "2024-06-15"
            }
          },
          "mbci-kaufland-raffle-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-05-20",
              end: "2024-07-31"
            }
          },
          "ariel-wama-raffle-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-05-20",
              end: "2024-06-30"
            }
          },
          "lidl-mbci-raffle-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-05-20",
              end: "2024-06-30"
            }
          },
          "gillette-loyalty-lilly-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-05-27",
              end: "2024-07-31"
            }
          },
          "kaufland-grocery-raffle-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-05-28",
              end: "2024-07-31"
            }
          },
          "pampers-loyalty-billa-bg-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-06-14",
              end: "2024-09-20"
            }
          },
          "always-bg-raffle-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-07-04",
              end: "2024-08-11"
            }
          },
          "lenor-moneyback-bg-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            downloadVoucher: true,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-07-04",
              end: "2024-09-30"
            }
          },
          "hs-raffle-july-2024-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            downloadVoucher: true,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-07-11",
              end: "2024-09-01"
            }
          },
          "metro-beauty-bg-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            downloadVoucher: true,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-07-11",
              end: "2024-08-31"
            }
          },
          "oralb-cashback-25-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-07-26",
              end: "2026-06-30"
            }
          },
          "always-lilly-august-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            downloadVoucher: true,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-07-26",
              end: "2024-08-31"
            }
          },
          "pampers-loyalty-kaufland-aug-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            downloadVoucher: true,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-08-07",
              end: "2024-11-03"
            }
          },
          "fabric-care-aug-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            downloadVoucher: true,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-08-13",
              end: "2024-09-18"
            }
          },
          "mbci-kaufland-cms-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-08-20",
              end: "2024-09-29"
            }
          },
          "oldspice-aug-24-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-08-21",
              end: "2024-09-15"
            }
          },
          "oralb-sep-dm-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-08-26",
              end: "2024-09-11"
            }
          },
          "oralb-raffle-sep-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-08-26",
              end: "2024-09-30"
            }
          },
          "billa-autumn-bg-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-09-04",
              end: "2024-10-02"
            }
          },
          "always-cashback-bg-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-09-24",
              end: "2024-12-31"
            }
          },
          "lidl-babycare-bg24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-10-08",
              end: "2024-11-13"
            }
          },
          "pantene-kaufland-bg24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-10-18",
              end: "2024-11-30"
            }
          },
          "oralb-kaufland-bg24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-10-18",
              end: "2024-11-30"
            }
          },
          "gifting-bg-nov24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-10-18",
              end: "2024-12-31"
            }
          },
          "ariel-rafflebg-nov24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-10-28",
              end: "2024-12-22"
            }
          },
          "gillette-lillybg-nov24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-10-22",
              end: "2024-11-30"
            }
          },
          "gillette-kauflandbg-nov24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2024-10-23",
              end: "2024-12-01"
            }
          },
          "always-kaufland-bg-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-01-21",
              end: "2025-02-23"
            }
          },
          "ariel-wama-bg-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-01-27",
              end: "2025-03-30"
            }
          },
          "lidl-fabric-bg-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-01-28",
              end: "2025-03-03"
            }
          },
          "fairy-loyalty-bg-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-01-29",
              end: "2025-04-06"
            }
          },
          "hs-cashback-bg-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-02-25",
              end: "2025-03-31"
            }
          },
          "gillette-lidl-bg-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-03-18",
              end: "2025-04-16"
            }
          },
          "mbci-bg-april-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-04-09",
              end: "2025-05-31"
            }
          },
          "loyalty-june-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-06-01",
              end: "2025-07-31"
            }
          },
          "oralb-dm-june-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-05-29",
              end: "2025-06-11"
            }
          },
          "gillette-kaufland-june-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-06-01",
              end: "2025-06-30"
            }
          },
          "pantene-june-2025-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-06-01",
              end: "2025-06-30"
            }
          },
          "oralb-kaufland-june-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-06-01",
              end: "2025-06-30"
            }
          },
          "oralb-lilly-june-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-06-01",
              end: "2025-06-30"
            }
          },
          "oldspice-bg-june-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-05-28",
              end: "2025-07-11"
            }
          },
          "pampers-bg-june-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-06-02",
              end: "2025-08-31"
            }
          },
          "pampers-care-bg-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-06-13",
              end: "2025-07-20"
            }
          },
          "fairy-june-bg-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-06-13",
              end: "2025-07-20"
            }
          },
          "lenor-july-bg-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-06-16",
              end: "2025-08-15"
            }
          },
          "pampers-new-july-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-06-18",
              end: "2025-10-31"
            }
          },
          "haircare-july-bg-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-08-18",
              end: "2025-09-28"
            }
          },
          "always-kaufland-bg-july": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-07-11",
              end: "2025-08-24"
            }
          },
          "mbci-billa-bg-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-07-14",
              end: "2025-08-30"
            }
          },
          "always-lilly-august-bg25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-07-25",
              end: "2025-08-31"
            }
          },
          "venus-bg-aug25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-07-28",
              end: "2025-08-31"
            }
          },
          "always-lidl-aug25-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-07-28",
              end: "2025-09-03"
            }
          },
          "ariel-lenor-aug25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-08-11",
              end: "2025-10-15"
            }
          },
          "fabric-aug-bg25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-08-11",
              end: "2025-09-17"
            }
          },
          "autumn-cleaning-bg25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-08-11",
              end: "2025-09-22"
            }
          },
          "old-spice-july-bg25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-08-18",
              end: "2025-09-28"
            }
          },
          "bts-bg-raffle-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-08-19",
              end: "2025-09-30"
            }
          },
          "always-cashback-bg25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-08-19",
              end: "2025-09-30"
            }
          },
          "billa-sep-bg25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-08-22",
              end: "2025-10-02"
            }
          },
          "mbci-lidl-sep25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-09-05",
              end: "2025-11-09"
            }
          },
          "mbci-kaufland-sep25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-09-05",
              end: "2025-10-19"
            }
          },
          "mbci-bg-oct-25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-09-05",
              end: "2025-11-23"
            }
          },
          "pampers-lidl-oct25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-10-09",
              end: "2025-11-16"
            }
          },
          "gillette-ucl-bg25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-10-20",
              end: "2025-12-31"
            }
          },
          "homecare-raffle-nov25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-10-21",
              end: "2025-11-30"
            }
          },
          "kaufland-fabric-nov25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-10-21",
              end: "2025-12-28"
            }
          },
          "billa-nov-bg25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-11-03",
              end: "2025-12-03"
            }
          },
          "pantene-dec-bg25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-11-03",
              end: "2025-11-26"
            }
          },
          "always-dm-dec25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-11-14",
              end: "2025-12-10"
            }
          },
          "gillette-lidl-bg25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-11-14",
              end: "2025-12-31"
            }
          },
          "gifting-dec-bg25": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-11-14",
              end: "2025-12-31"
            }
          },
          "always-lilly-bg26": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-12-15",
              end: "2026-02-28"
            }
          },
          "lenor-dec25-bg": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            countries: ["Bulgaria"],
            timeLimits: {
              start: "2025-12-15",
              end: "2026-01-11"
            }
          },
        }
      },
      { // P&G DACH NEW
        name: "PG DACH NEW",
        campaignId: "pg-template-2",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasPendingReceipt: true,
        hasOnHoldReceipts: true,
        hasWinnerList: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasRaffle: true,
        participationCounts: true,
        hasAdditionalPayment: true,
        hasGoodWill: [
          "ppv-styling-dach-23",
          "campaign1",
          "olympics-raffle",
          "de-wick-24",
          "lenor-light-24",
          "ninjamas-dach",
          "always-aldi-2024",
          "clearblue-de-23",
          "gillette-paarship-de",
          "oralb-gratis-testen-2024",
          "fruehling-de-24",
          "always-1eur-dach",
          "fairy-max-power-24",
          "fairy-bbq-24",
          "pampers-night-24",
          "swiffer-pink-de",
          "glabs-50cb-dach",
          "neuheiten-testen-de",
          "pampers-cb-es-1",
          "pampers-pp-dm",
          "pampers-s4-dm",
          "pampers-coupon-de",
          "zq-gewinnspiel-de",
          "fairy-grill-24",
          "oralb-de-24",
          "rossmann-olympics-24",
          "penny-olympics-24",
          "mediamarkt-ch",
          "akatronik-at",
          "casa-bugatti-at",
          "0815-at",
          "dilife-at",
          "national-raffle-at",
          "mediamarkt-at",
          "pg-uk-cashback"
        ],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          // base: "http://127.0.0.1:3001/api/dashboard",
          base: "https://template-v3.justsnap.eu/api/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceiptV2",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct",
          additionalPayment: '/createAdditionalPayment'
        },
        campaigns: {
          "ppv-styling-dach-23": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2023-10-26",
              end: "2023-12-31"
            }
          },
          "campaign1": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2023-10-26",
              end: "2023-12-31"
            }
          },
          "olympics-raffle": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            hasRaffleEmail: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-02-01",
              end: "2024-05-15"
            }
          },
          "de-wick-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-12-27",
              end: "2024-03-31"
            }
          },
          "lenor-light-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2024-01-15",
              end: "2024-06-15"
            }
          },
          "ninjamas-dach": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2024-01-01",
              end: "2025-05-08"
            }
          },
          "always-aldi-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2023-12-20",
              end: "2024-01-19"
            }
          },
          "clearblue-de-23": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasParallelCampaign: false,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2024-01-02",
              end: "2024-03-31"
            }
          },
          "gillette-paarship-de": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-01-22",
              end: "2024-03-31"
            }
          },
          "oralb-gratis-testen-2024": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2024-02-01",
              end: "2024-03-31"
            }
          },
          "fruehling-de-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-02-01",
              end: "2024-03-31"
            }
          },
          "always-1eur-dach": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2024-02-01",
              end: "2024-09-30"
            }
          },
          "fairy-max-power-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2024-02-01",
              end: "2024-06-30"
            }
          },
          "ariel-de-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-02-01",
              end: "2024-06-30"
            }
          },
          "fairy-bbq-24": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2024-02-01",
              end: "2024-07-15"
            }
          },
          "pampers-night-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2024-02-15",
              end: "2024-04-15"
            }
          },
          "swiffer-pink-de": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2024-04-01",
              end: "2024-08-17"
            }
          },
          "glabs-50cb-dach": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2024-03-01",
              end: "2024-03-31"
            }
          },
          "neuheiten-testen-de": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-04-01",
              end: "2024-05-31"
            }
          },
          "pampers-cb-es-1": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            hasServiceOpReEvaluate: true,
            countries: ["Spain"],
            timeLimits: {
              start: "2024-10-16",
              end: "2024-12-31"
            }
          },
          "pampers-pp-dm": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-04-15",
              end: "2024-06-15"
            }
          },
          "pampers-s4-dm": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-04-15",
              end: "2024-06-15"
            }
          },
          "pampers-coupon-de": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-04-26",
              end: "2024-05-31"
            }
          },
          "zq-gewinnspiel-de": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-04-26",
              end: "2024-05-31"
            }
          },
          "pg-gewinnspiel-aldi-ch": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            noReceiptReuploadLink: false,
            noProductReuploadLink: false,
            hasRaffleEmail: true,
            countries: ["Switzerland"],
            timeLimits: {
              start: "2024-05-16",
              end: "2024-05-21"
            }
          },
          "pg-gewinnspiel-aldi-at": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            noReceiptReuploadLink: false,
            noProductReuploadLink: false,
            hasRaffleEmail: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2024-05-23",
              end: "2024-05-29"
            }
          },
          "pg-gewinnspiel-aldi-de": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            noReceiptReuploadLink: false,
            noProductReuploadLink: false,
            hasRaffleEmail: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-05-29",
              end: "2024-06-04"
            }
          },
          "fairy-grill-24": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            rossmannDiscount: true,
            hasVatMetro: false,
            hasRetailer: false,
            hasInvoice: false,
            hasVatNumber: false,
            noCashbackEdit: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2024-05-01", // original 2024-06-01
              end: "2024-11-15"
            }
          },
          "pg-gewinnspiel-mueller-de": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            noReceiptReuploadLink: false,
            noProductReuploadLink: false,
            hasRaffleEmail: true,
            removeIbanReupload: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-06-05", // Original 2024-06-03
              end: "2024-06-19"
            }
          },
          "oralb-de-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-06-03",
              end: "2024-06-16"
            }
          },
          "rossmann-olympics-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-06-10",
              end: "2024-06-21"
            }
          },
          "penny-olympics-24": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-06-14",
              end: "2024-06-29"
            }
          },
          "pg-gewinnspiel-globus-de": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            noReceiptReuploadLink: false,
            noProductReuploadLink: false,
            hasRaffleEmail: true,
            removeIbanReupload: true,
            countries: ["Germany"],
            timeLimits: {
              start: "2024-06-21",
              end: "2024-06-30"
            }
          },
          "mediamarkt-ch": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            hasRaffleEmail: true,
            countries: ["Switzerland"],
            timeLimits: {
              start: "2024-07-16",
              end: "2024-08-25"
            }
          },
          "akatronik-at": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            hasRaffleEmail: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2024-07-10",
              end: "2024-08-18"
            }
          },
          "casa-bugatti-at": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            hasRaffleEmail: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2024-07-10",
              end: "2024-08-18"
            }
          },
          "0815-at": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            hasRaffleEmail: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2024-07-10",
              end: "2024-08-18"
            }
          },
          "dilife-at": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            hasRaffleEmail: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2024-07-10",
              end: "2024-08-18"
            }
          },
          "national-raffle-at": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            hasRaffleEmail: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2024-07-10",
              end: "2024-08-18"
            }
          },
          "mediamarkt-at": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            hasRaffleEmail: true,
            countries: ["Austria"],
            timeLimits: {
              start: "2024-07-10",
              end: "2024-08-18"
            }
          },
          "pg-uk-cashback": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: true,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["uk"],
            timeLimits: {
              start: "2024-07-23",
              end: "2024-08-07"
            }
          },
        }
      },
      { // P&G Ukraine
        name: "PG Ukraine",
        campaignId: "pg-ukraine",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasPendingReceipt: true,
        hasOnHoldReceipts: true,
        hasWinnerList: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasRaffle: true,
        participationCounts: true,
        hasGoodWill: [
          "ua-mbci-03-2024-100",
          "ua-mbci-03-2024-200",
          "ua-mbci-03-2024-400",
          "ua-mbci-03-2024-500",
          "ua-mbci-10-2024-100",
          "ua-mbci-10-2024-250",
          "ua-mbci-10-2024-500",
          "ua-mbci-10-2024-750",
          "ua-mbci-10-2025-100",
          "ua-mbci-10-2025-250",
          "ua-mbci-10-2025-500",
          "ua-mbci-10-2025-750",
        ],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          // base: "http://127.0.0.1:3001/api/dashboard",
          base: "https://pg-ukraine-be.jsnp.io/api/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct"
        },
        campaigns: {
          "ua-mbci-03-2024-100": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2024-03-12",
              end: "2024-06-21"
            }
          },
          "ua-mbci-03-2024-200": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2024-03-12",
              end: "2024-06-21"
            }
          },
          "ua-mbci-03-2024-400": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2024-03-12",
              end: "2024-06-21"
            }
          },
          "ua-mbci-03-2024-500": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2024-03-12",
              end: "2024-06-21"
            }
          },
          "ua-mbci-10-2024-100": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2024-09-12",
              end: "2024-12-15"
            }
          },
          "ua-mbci-10-2024-250": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2024-09-12",
              end: "2024-12-15"
            }
          },
          "ua-mbci-10-2024-500": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2024-09-12",
              end: "2024-12-15"
            }
          },
          "ua-mbci-10-2024-750": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2024-09-12",
              end: "2024-12-15"
            }
          },
          "ua-mbci-10-2025-100": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2025-10-01",
              end: "2025-11-30"
            }
          },
          "ua-mbci-10-2025-250": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2025-10-01",
              end: "2025-11-30"
            }
          },
          "ua-mbci-10-2025-500": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2025-10-01",
              end: "2025-11-30"
            }
          },
          "ua-mbci-10-2025-750": {
            hasProduct: true,
            priceEditable: true,
            hasParallelCampaign: false,
            hasRetailer: true,
            hasInvoice: false,
            rossmannDiscount: true,
            countries: ["Ukraine"],
            timeLimits: {
              start: "2025-10-01",
              end: "2025-11-30"
            }
          },
        }
      },
      //RAKUTEN
      {
        name: "Philips Rakuten",
        campaignId: "tpv-pl-ro",
        isCroppable: false,
        needsCrop: false,
        hasOrderId: true,
        hasRetailer: true,
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vS8f8NCwNN1EjHkP5JuMYIoeix5guyO634KwYj_Knd-LSVVRWkTAWT6ujN5vxlffMsAl2zmsI6yNUZk/embed?start=true&loop=false&delayms=3000",
        endPoints: {
          // base: "https://gillette-ucl.justsnap.de/api/dashboard",
          base: "https://philips-rakutentv.com/api/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          performance: "/dashboarderStatistics",
          exportExcel: "/exportExcel"
        },
        campaigns: {
          "tpv-ro": {
            hasProduct: true,
            priceEditable: false,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Romania"],
            timeLimits: {
              start: "2021-06-07",
              end: "2021-08-31"
            }
          },
          "tpv-pl": {
            hasProduct: true,
            priceEditable: false,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["Poland"],
            timeLimits: {
              start: "2021-05-24",
              end: "2021-08-31"
            }
          },
          "tpv-uk": {
            hasProduct: true,
            priceEditable: false,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            countries: ["uk"],
            timeLimits: {
              start: "2022-03-01",
              end: "2022-04-05"
            }
          }
        }
      },
      //RAKUTEN SOUNDBOOST
      {
        name: "Philips Sound Boost",
        campaignId: "philips-soundboost",
        isCroppable: false,
        needsCrop: false,
        hasOrderId: true,
        hasRetailer: true,
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vS8f8NCwNN1EjHkP5JuMYIoeix5guyO634KwYj_Knd-LSVVRWkTAWT6ujN5vxlffMsAl2zmsI6yNUZk/embed?start=true&loop=false&delayms=3000",
        endPoints: {
          //base: "http://127.0.0.1:3000/api/dashboard",
          base: "https://soundboost-rakutentv.com/api/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          performance: "/dashboarderStatistics",
          exportExcel: "/exportExcel"
        },
        timeLimits: {
          start: "2021-02-22",
          end: "2021-06-30"
        }
      },
      //Philips-Headphone
      {
        name: "Philips-Headphone",
        campaignId: "philips-headphone",
        isCroppable: false,
        needsCrop: false,
        hasOrderId: true,
        hasRetailer: true,
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vS8f8NCwNN1EjHkP5JuMYIoeix5guyO634KwYj_Knd-LSVVRWkTAWT6ujN5vxlffMsAl2zmsI6yNUZk/embed?start=true&loop=false&delayms=3000",
        endPoints: {
          // base: "https://gillette-ucl.justsnap.de/api/dashboard",
          base: "https://rytmtreningu.pl/api/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          performance: "/dashboarderStatistics",
          exportExcel: "/exportExcel"
        },
        timeLimits: {
          start: "2022-06-10",
          end: "2022-10-02"
        }
      },
      //FB BOT
      {
        name: "FB BOT",
        campaignId: "FB-BOT",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        participationCounts: true,
        exportWinnerList: true,
        extraRetailerField: false,
        hasGoodWill: ["belvita-bot-ro", "tuc-bot-ro"],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          base: "https://fb-bot-v2.justsnap.eu/api/dashboard",
          // base: 'http://127.0.0.1:3000/api/dashboard',
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          locations: "/allLocations",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel"
        },
        campaigns: {
          "belvita-bot-ro": {
            priceEditable: true,
            onlyOneProduct: true,
            hasRetailer: true,
            // countries: ["Romania"],
            timeLimits: {
              start: "2020-11-12",
              end: "2020-12-10"
            }
          },
          "leerdammer-bot-mega": {
            priceEditable: true,
            onlyOneProduct: true,
            hasRetailer: true,
            // countries: ["Romania"],
            timeLimits: {
              start: "2020-10-26"
            }
          },
          "leerdammer-bot-carrefour": {
            priceEditable: true,
            onlyOneProduct: true,
            hasRetailer: true,
            // countries: ["Romania"],
            timeLimits: {
              start: "2020-10-26"
            }
          },
          "jacobs-bot-ro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-02-01",
              end: "2021-03-31"
            }
          },
          "tuc-bot-ro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            hasProductImageTable: true,
            productImageTableUrl:
              "https://jolt-assets.s3.eu-central-1.amazonaws.com/template/tucbot-products-table.png",
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-07-01",
              end: "2021-07-31"
            }
          },
          "jacobs-2.0-bot": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-08-02",
              end: "2021-09-12"
            }
          },
          "belvita-2.0-bot": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-08-02",
              end: "2021-09-12"
            }
          },
          "lor-bot-ro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-08-12",
              end: "2021-08-31"
            }
          },
          "jacobs-3.0-bot": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-09-01",
              end: "2021-10-31"
            }
          },
          "freisland-bot-ro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-09-01",
              end: "2021-10-09"
            }
          },
          "lavazza-bot-ro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-09-13",
              end: "2021-10-24"
            }
          },
          "pepsi-bot-ro": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-10-21",
              end: "2021-11-17"
            }
          },
          "lor-bor-cora": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-10-20",
              end: "2021-11-02"
            }
          },
          "lor-bor-mega": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-10-21",
              end: "2021-11-17"
            }
          },
          "lor-bot-carrefour": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-11-04",
              end: "2021-11-17"
            }
          },
          "pepsi-mega-bot": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-11-18",
              end: "2021-12-31"
            }
          },
          "pepsi-hoodie-bot": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-11-17",
              end: "2021-12-15"
            }
          },
          "pepsi-horeca-bot": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-11-25",
              end: "2021-12-31"
            }
          },
          "tuc-ladoipasi": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2021-12-28",
              end: "2022-02-03"
            }
          },
          "julius-bot-2.0": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2022-04-13",
              end: "2022-05-31"
            }
          },
          "mondolez-milka": {
            hasProduct: true,
            priceEditable: true,
            onlyOneProduct: false,
            hasRetailer: false,
            hasInvoice: false,
            // countries: ["Romania"],
            timeLimits: {
              start: "2022-10-03",
              end: "2022-10-31"
            }
          }
        }
      },
      {
        name: "Lenor Jahre",
        campaignId: "lenor-60-jahre",
        isCroppable: false,
        needsCrop: false,
        hasReceiptId: true,
        hasReuploadLink: true,
        hasRejectedReceipt: true,
        hasBlackList: true,
        hasPendingReceipt: true,
        participationCounts: true,
        hasGoodWill: ["lenor-60-jahre"],
        details:
          "https://docs.google.com/presentation/d/e/2PACX-1vQMLVHOJgwsBByx6LBjMiQ1xIj-Q6gpVF4qsVyA1pIMAuighDbjJuCi6qlIiFpzuE1zjf_OPfYsxJDL/embed?start=false&loop=false&delayms=3000",
        endPoints: {
          // base: "http://127.0.0.1:3000/dashboard",
          base: "https://jenor-60.jsnp.io/dashboard",
          getOneReceipt: "/getOneReceipt",
          rejectReceipt: "/rejectReceipt",
          confirmReceipt: "/confirmReceipt",
          products: "/productList",
          login: "/login",
          dropReceipt: "/dropReceipt",
          allReceipts: "/receipts",
          dashboardData: "/dashboardData",
          refrenceNumber: "/getReferenceNumber",
          receiptByToken: "/getReceiptByToken",
          reEvaluate: "/reEvaluate",
          confirmGoodwill: "/confirmReceiptGW",
          performance: "/dashboarderStatistics",
          recentReceipts: "/recentReceipts",
          searchReceipt: "/searchReceipt",
          exportExcel: "/exportExcel",
          getRejectedReceipts: "/getRejectedReceipts",
          addBlackListItem: "/addBlackListItem",
          uploadBlackListFile: "/uploadBlackListFile",
          searchBlackListItem: "/searchBlackListItem",
          updateBlackListItem: "/updateBlackListItem",
          deleteBlackListItem: "/deleteBlackListItem",
          getAllBlackListItem: "/getAllBlackListItem",
          getParallelCampaignProduct: "/getParallelCampaignProduct"
        },
        campaigns: {
          "lenor-60-jahre": {
            priceEditable: true,
            hasRetailer: true,
            countries: ["Germany", "Austria", "Switzerland"],
            timeLimits: {
              start: "2022-04-01",
              end: "2022-12-01"
            }
          },
          "lenor-60-jahre-dev": {
            priceEditable: true,
            hasRetailer: true,
            countries: ["Germany", "Austria"],
            timeLimits: {
              start: "2022-09-01",
              end: "2022-12-01"
            }
          }
        }
      }
    ];
    return dashboards;
  },
  errorHandler({ dispatch }, error) {
    if (!error.status) {
      return dispatch("snackAlert", { message: error });
    }
    switch (error.status) {
      case 401:
        router.push({ name: "logout" });
        dispatch("snackAlert", {
          message: "Authorization Problem. Please login again. ¯\\_(ツ)_/¯"
        });
        break;
      default:
        dispatch("snackAlert", { message: error.statusText });
    }
  },

  updateUserToken({ commit }, value) {
    commit("setUserToken", value);
    return true;
  },

  getProductsList({ dispatch }, value) {
    const { dashboard, campaignId } = value;
    const endPoint = dashboard.endPoints.base + dashboard.endPoints.products;
    return axios
      .get(`${endPoint}?campaignId=${campaignId}`)
      .then((response) => {
        if (response.data.response) {
          return response.data.products;
        } else {
          return {};
        }
      })
      .catch((er) => {
        dispatch("errorHandler", er.response);
      });
  },

  getDashboardData({ commit, dispatch }, val) {
    return new Promise((resolve, reject) => {
      const { userToken, dashboard, campaign_fk } = val;
      if (campaign_fk && !dashboard.campaigns[campaign_fk]) {
        dispatch("errorHandler", "Campaign not found");
        reject("Campaign not found");
      }
      if ("endPoints" in dashboard) {
        const base =
          campaign_fk && dashboard.campaigns[campaign_fk].hasSpecialBase
            ? dashboard.campaigns[campaign_fk].base
            : dashboard.endPoints.base;

        const endPoint = base + dashboard.endPoints.dashboardData;
        axios({
          method: "post",
          url: `${endPoint}`,
          data: {
            userToken,
            campaignId: campaign_fk
          }
        })
          .then((response) => {
            if (response.data.response) {
              // commit('setUserRoles', response.data.roles);
              commit("setRejectReasons", response.data.rejectMessages);
              // Set the decline reasons the same as reject reasons
              commit("setDeclineReasons", response.data.rejectMessages);
              commit("setReclaimReasons", response.data.reclaimReasons);
              // commit('setLocations', response.data.locations)
              if (response.data.dashboarders && response.data.dashboarders.length)
                commit("setDashboardersList", [
                  { id: -1, email: "All Dashboarders" },
                  ...response.data.dashboarders
                ]);
              // commit('setCampaignsList', [...response.data.campaigns])
              resolve(response.data.products)
            } else {
              dispatch(
                "errorHandler",
                response.data.message || response.data.error
              );
              reject(response.data);
            }
          })
          .catch((er) => {
            dispatch("errorHandler", er.response);
            reject(er);
          });
      }
    });
  },

  getPerformance({ dispatch }, val) {
    const { userToken, dashboard } = val;
    const endPoint = dashboard.endPoints.base + dashboard.endPoints.performance;
    return new Promise((resolve, reject) => {
      axios
        .post(endPoint, { userToken: userToken })
        .then((response) => {
          if (response.data.response) resolve(response.data);
          else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            resolve(false);
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er);
          reject(er);
        });
    });
  },

  getReceiptByToken({ dispatch }, value) {
    return new Promise((resolve, reject) => {
      const { userToken, receiptToken, dashboard } = value;
      const endPoint =
        dashboard.endPoints.base + dashboard.endPoints.receiptByToken;
      axios({
        method: "post",
        url: `${endPoint}`,
        data: {
          userToken,
          receiptToken
        }
      }).then((response) => {
        if (response.data.response) {
          return resolve(response.data);
        } else {
          dispatch("snackAlert", { message: response.data.error });
          reject(response.data);
        }
      });
    });
  },

  getReceiptwithRefNumber({ dispatch, commit }, value) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${value.dashboard.endPoints.base}/getReferenceNumber/${value.userToken}/${value.referenceNumber}`
        )
        .then((response) => {
          commit("setFraudModelScore", "");
          commit("setFraudResult", "");
          commit("setProcessHistory", []);
          commit("setFraudModelWeights", {})
          if (response.data.response) {
            commit("setFraudRiskScore", response.data.receipt?.fraudRiskScore || "")
            commit("setFraudModelScore", response.data.receipt?.fraudModelScore >= 0 ? response.data.receipt?.fraudModelScore : "");
            commit("setFraudResult", response.data.receipt?.fraudResult || "");
            commit("setProcessHistory", response.data.receipt?.processHistory || []);
            commit("setFraudModelWeights", response.data.receipt?.fraudModelWeights || {})
            return resolve(response.data);
          } else {
            dispatch("snackAlert", { message: response.data.error });
            reject(response.data);
          }
        });
    });
  },

  getReceiptsWithConsumerInfo({ dispatch, getters }, value) {
    return axios
      .post(`${value.dashboard.endPoints.base}/getReceiptsWithConsumerInfo`, { ...value, userToken: getters.userToken })
      .then(res => {
        if (res.data.response && res.data.receipts) {
          return res.data
        } else if (res.data.error) {
          throw res.data.error
        } else throw res.data
      })
      .catch(err => {
        dispatch("snackAlert", { message: err });
        return err.response
      });
  },

  getPrevParticipations({ dispatch }, value) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${value.dashboard.endPoints.base}/prevParticipations/${value.userToken}/${value.referenceNumber}`
        )
        .then((response) => {
          if (response.data.response) {
            return resolve(response.data);
          } else {
            dispatch("snackAlert", { message: response.data.error });
            reject(response.data);
          }
        });
    });
  },

  getEmailParticipations({ dispatch }, value) {
    const data = {
      userToken: value.userToken,
      email: value.email
    }
    return new Promise((resolve, reject) => {
      axios
        .post(`${value.dashboard.endPoints.base}/searchByUserData`, data)
        .then((response) => {
          if (response.data.response) {
            return resolve(response.data);
          } else {
            dispatch("snackAlert", { message: response.data.error });
            reject(response.data);
          }
        });
    });
  },

  sendReEvaluation({ commit, dispatch }, value) {
    const { userToken, receiptToken, dashboard, reClaimText, reClaimReason } = value;
    const endPoint = dashboard.endPoints.base + dashboard.endPoints.reEvaluate;

    return new Promise((resolve, reject) => {
      axios
        .post(`${endPoint}`, {
          receiptToken,
          userToken,
          reClaimText,
          reClaimReason
        })
        .then((retval) => {
          if (retval.data.response) {
            return resolve(true);
          } else {
            if (retval.data.error === "404") {
              commit("setUserToken", "");
              this.$router.push("/");
            } else {
              dispatch("errorHandler", retval.data.error);
              reject(retval.data.error);
            }
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
        });
    });
  },

  declineReceipt({ commit, dispatch }, value) {
    const {
      userToken,
      receiptToken,
      dashboard,
      sendEmail,
      rejectReason,
      customerToken,
      campaignId,
      fraud,
      brokenProduct,
      isDigital
    } = value;
    const endPoint =
      dashboard.endPoints.base + dashboard.endPoints.rejectReceipt;
    return new Promise((resolve, reject) => {
      axios
        .post(`${endPoint}`, {
          userToken,
          receiptToken,
          sendEmail,
          rejectReason,
          customerToken,
          campaignId,
          fraud,
          brokenProduct,
          isDigital
        })
        .then((retval) => {
          if (retval.data.response) {
            return resolve(true);
          } else {
            if (retval.data.error === "404") {
              commit("setUserToken", "");
              this.$router.push("/");
            } else {
              dispatch("errorHandler", retval.data.error);
              reject(retval.data.error);
            }
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
        });
    });
  },

  confirmGoodwill({ commit, dispatch }, data) {
    const { dashboard, campaignId } = data;
    const base =
      campaignId &&
        dashboard.campaigns &&
        dashboard.campaigns[campaignId].hasSpecialBase
        ? dashboard.campaigns[campaignId].base
        : dashboard.endPoints.base;
    const endPoint = base + dashboard.endPoints.confirmGoodwill;
    delete data.dashboard
    return new Promise((resolve, reject) => {
      axios
        .post(`${endPoint}`, data)
        .then((retval) => {
          if (retval.data.response) {
            return resolve(true);
          } else {
            if (retval.data.error === "404") {
              commit("setUserToken", "");
              this.$router.push("/");
            } else {
              dispatch("errorHandler", retval.data.error);
              reject(retval.data.error);
            }
          }
        })
        .catch((er) => {
          reject(er);
          dispatch("errorHandler", er.response);
        });
    });
  },

  login({ commit, dispatch }, value) {
    const { user, dashboard } = value;
    // console.log(dashboard);
    // const _user = {
    //   ...user,
    //   campaignId: dashboard.campaignId
    // };

    if ("endPoints" in dashboard) {
      const endPoint = dashboard.endPoints.base + dashboard.endPoints.login;

      return axios
        .post(`${endPoint}`, user)
        .then((response) => {
          if (response.data.response) {
            commit("setUserToken", response.data.userToken);
            commit("setUserRoles", response.data);
            commit("setDashboard", dashboard);
            const date = new Date();
            const sevenDays = 7 * 24 * 60 * 60 * 1000;
            date.setTime(date.getTime() + sevenDays);
            const expires = "; expires=" + date.toUTCString();
            document.cookie =
              "userToken" +
              "=" +
              (response.data.userToken || "") +
              expires +
              "; path=/";

            return { response: true, level: response.data.level };
          }
          if (!response.data.response) {
            dispatch("snackAlert", {
              message: "There was an problem logging in!"
            });
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
        });
    } else {
      return dispatch("snackAlert", { message: "Select a campaign." });
    }
  },

  checkUserToken({ dispatch }, userToken) {
    return axios
      .post(`${APIUrl}/checkToken`, { userToken: userToken })
      .then((response) => {
        return response.data.response;
      })
      .catch((er) => {
        dispatch("errorHandler", er.response);
      });
  },

  getAllReceipts({ dispatch }, value) {
    return new Promise((resolve, reject) => {
      const { userToken, dashboard } = value;
      const endPoint =
        dashboard.endPoints.base + dashboard.endPoints.allReceipts;

      axios
        .get(`${endPoint}/${userToken}`)
        .then((response) => {
          if (response.data.response) return resolve(response.data);
          else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            resolve(false);
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
          reject(er);
        });
    });
  },

  getRecentReceipts({ dispatch }, payload) {
    const { dashboard } = payload;
    const endPoint =
      dashboard.endPoints.base + dashboard.endPoints.recentReceipts;
    return new Promise((resolve, reject) => {
      axios
        .post(`${endPoint}`, {
          userToken: `${payload.userToken}`,
          limit: `${payload.limit || 20}`,
          lastId: payload.lastId || ""
        })
        .then((response) => {
          if (response.data.response) return resolve(response.data);
          else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            resolve(false);
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
          reject(er);
        });
    });
  },

  updateReceiptId({ commit }, receiptId) {
    commit("setSelectedReceiptId", receiptId);
  },

  getReceiptDetails({ dispatch }, value) {
    return Promise((resolve, reject) => {
      axios
        .get(`${APIUrl}/getReceipt/${value.userToken}/${value.receiptToken}`)
        .then((response) => {
          if (response.data.response) return resolve(response.data);
          else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            reject(response.data);
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
          reject(er);
        });
    });
  },

  getReceiptWithId({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      if (this.cancel !== undefined) {
        this.cancel();
      }
      var CancelToken = axios.CancelToken;
      axios({
        method: "post",
        url: `${APIUrl}/getReceiptWithId`,
        data,
        cancelToken: new CancelToken((c) => {
          this.cancel = c;
        })
      })
        .then((response) => {
          if (response.data.response) resolve(response.data);
          else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            resolve(false);
          }
        })
        .catch(function (er) {
          if (!axios.isCancel(er)) {
            dispatch("errorHandler", er.response);
            reject(er);
          }
        });
    });
  },

  getAnyReceiptWithId({ commit, dispatch }, data) {
    if (this.cancel !== undefined) {
      this.cancel();
    }
    // var CancelToken = axios.CancelToken;

    return new Promise((resolve, reject) => {
      axios
        .post(`${APIUrl}/getAnyReceiptWithId`, data)
        .then((response) => {
          commit("clearCurrentReceipt");
          commit("setFraudRiskScore", "");
          if (response.data.response) {
            commit("setFraudRiskScore", response.data.receipt?.fraudRiskScore || "");
            resolve(response.data);
          } else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            resolve(false);
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
          reject(er);
        });
    });
  },

  getOneReceipt({ commit, dispatch }, value) {
    return new Promise((resolve, reject) => {
      const { userToken, dashboard } = value;
      const endPoint =
        dashboard.endPoints.base + dashboard.endPoints.getOneReceipt;

      if (this.cancel !== undefined) {
        this.cancel();
      }
      var CancelToken = axios.CancelToken;
      axios({
        method: "post",
        url: `${endPoint}`,
        data: { userToken },
        cancelToken: new CancelToken((c) => {
          this.cancel = c;
        })
      })
        .then((response) => {
          commit("clearCurrentReceipt");
          commit("setFraudRiskScore", "");
          commit("setFraudModelScore", "");
          commit("setFraudResult", "");
          commit("setProcessHistory", []);
          commit("setFraudModelWeights", {});

          if (response.data.response) {
            commit("setFraudRiskScore", response.data.receipt?.fraudRiskScore || "");
            commit("setFraudModelScore", response.data.receipt?.fraudModelScore >= 0 ? response.data.receipt?.fraudModelScore : "");
            commit("setFraudResult", response.data.receipt?.fraudResult || "");
            commit("setProcessHistory", response.data.receipt?.processHistory || []);
            commit("setFraudModelWeights", response.data.receipt?.fraudModelWeights || {});
            resolve(response.data);
          }
          else {
            {
              dispatch(
                "errorHandler",
                response.data.message || response.data.error
              );
              resolve(false);
            }
          }
        })
        .catch(function (er) {
          if (!axios.isCancel(er)) {
            dispatch("errorHandler", er.response);
            reject(er);
          }
          reject(er);
        });
    });
  },

  updateDialogOpenState({ commit }, value) {
    commit("setDialogOpen", value);
  },

  rejectReceipt({ commit, dispatch }, value) {
    const {
      userToken,
      dashboard,
      rejectReason,
      receiptToken,
      customerToken,
      campaignId,
      fraud,
      brokenProduct,
      isDigital
    } = value;
    // console.log("inside REJECT>>>", value);

    const base =
      campaignId &&
        dashboard.campaigns &&
        dashboard.campaigns[campaignId].hasSpecialBase
        ? dashboard.campaigns[campaignId].base
        : dashboard.endPoints.base;
    const endPoint = base + dashboard.endPoints.rejectReceipt;
    commit("setReceiptPendingStatus", true);

    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${endPoint}`,
        data: {
          userToken,
          receiptToken,
          rejectReason,
          customerToken,
          campaignId,
          fraud,
          brokenProduct,
          isDigital
        }
      })
        .then((response) => {
          if (response.data.response) return resolve(response.data);
          else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            resolve(false);
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
          reject(er);
        })
        .finally(() => {
          setTimeout(() => commit("setReceiptPendingStatus", false), 250);
        });
    });
  },

  saveReceipt({ commit, dispatch }, data) {
    if (
      data.status === "Confirmed" &&
      !moment(data.receipt.identifiedDate, "YYYY-MM-DD").isValid()
    ) {
      return dispatch("snackAlert", {
        message:
          "Something has gone wrong with the date field. Please change the date and try again."
      });
    }
    commit("setReceiptPendingStatus", true);
    return new Promise((resolve, reject) => {
      axios
        .post(`${APIUrl}/saveReceipt`, data)
        .then((response) => {
          return resolve(response.data);
        })
        .catch((er) => {
          reject(er.message);
          dispatch("errorHandler", er.response);
        })
        .finally(() => {
          setTimeout(() => commit("setReceiptPendingStatus", false), 250);
        });
    });
  },

  updateReceiptStatus({ commit, dispatch }, data) {
    commit("setReceiptPendingStatus", true);
    return new Promise((resolve, reject) => {
      axios
        .post(`${APIUrl}/updateReceipt`, data)
        .then((response) => {
          if (response.data.response) return resolve(response.data);
          else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            resolve(false);
          }
        })
        .catch((er) => {
          reject(er.message);
          dispatch("errorHandler", er.response);
        })
        .finally(() => {
          setTimeout(() => commit("setReceiptPendingStatus", false), 250);
        });
    });
  },

  getCampaignDetails({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${APIUrl}/getCampaignDetails`, data)
        .then((response) => {
          if (response.data.response) return resolve(response.data);
          else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            resolve(false);
          }
        })
        .catch((er) => {
          reject(er.message);
          dispatch("errorHandler", er.response);
        });
    });
  },

  confirmReceipt({ commit, dispatch }, value) {
    const {
      userToken,
      dashboard,
      rejectReason,
      receiptToken,
      customerToken,
      date,
      time,
      retailer,
      total,
      products,
      campaignId,
      fraud,
      brokenProduct,
      orderId,
      isDigital,
      // sendSftp,
      receiptId,
      country,
      extra,
      selectedCheckbox,
      location,
      postCode,
      vatNumber,
      sendEmail,
      clubCode,
      fiscalId
    } = value;

    const base =
      campaignId &&
        dashboard.campaigns &&
        dashboard.campaigns[campaignId].hasSpecialBase
        ? dashboard.campaigns[campaignId].base
        : dashboard.endPoints.base;
    const endPoint = base + dashboard.endPoints.confirmReceipt;
    commit("setReceiptPendingStatus", true);

    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${endPoint}`,
        data: {
          userToken,
          receiptToken,
          rejectReason,
          customerToken,
          date,
          time,
          retailer,
          total,
          products,
          campaignId,
          fraud,
          isDigital,
          brokenProduct,
          orderId,
          receiptId,
          country,
          extra,
          selectedCheckbox,
          location,
          postCode,
          vatNumber,
          sendEmail,
          clubCode,
          fiscalId
        }
      })
        .then((response) => {
          // console.log("inside then in actions", response);
          if (response.data.error || response.data.response == false) {
            reject(response.data);
          }
          resolve(response.data);
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
        })
        .finally(() => {
          setTimeout(() => commit("setReceiptPendingStatus", false), 250);
        });
    });
  },

  confirmReceiptGW({ dispatch }, value) {
    const { dashboard, campaignId } = value;
    const base =
      campaignId &&
        dashboard.campaigns &&
        dashboard.campaigns[campaignId].hasSpecialBase
        ? dashboard.campaigns[campaignId].base
        : dashboard.endPoints.base;

    delete value.dashboard
    return axios
      .post(`${base}/confirmReceiptGW/${value.userToken}`, value)
      .then((response) => {
        return response.data;
      })
      .catch((er) => {
        dispatch("errorHandler", er.response);
      });
  },

  dropReceipt({ commit, dispatch }, value) {
    return new Promise((resolve, reject) => {
      const { userToken, dashboard, receiptToken } = value;
      const endPoint =
        dashboard.endPoints.base + dashboard.endPoints.dropReceipt;

      if (endPoint.includes("dropReceiptV2")) {
        axios.get(`${endPoint}/${userToken}/${receiptToken}`)
          .then((response) => {
            if (response.data.response) {
              return resolve(response.data);
            }
            else {
              dispatch("errorHandler", response.data.message || response.data.error);
              resolve(false);
            }
          })
          .catch((er) => {
            dispatch("errorHandler", er.response);
            reject(er);
          });
      } else {
        axios
          .get(`${endPoint}/${userToken}`)
          .then((response) => {
            commit("clearCurrentReceipt");
            if (response.data.response) {
              commit("setFraudRiskScore", "");
              commit("setFraudRiskScore", response.data.receipt?.fraudRiskScore || "");
              return resolve(response.data)
            }
            else {
              {
                dispatch(
                  "errorHandler",
                  response.data.message || response.data.error
                );
                resolve(false);
              }
            }
          })
          .catch((er) => {
            dispatch("errorHandler", er.response);
            reject(er);
          });
      }
    });
  },

  searchReceipt({ dispatch }, data) {
    // console.log(data);
    return new Promise((resolve, reject) => {
      const { dashboard } = data;
      const endPoint =
        dashboard.endPoints.base + dashboard.endPoints.searchReceipt;
      if (this.cancel !== undefined) {
        this.cancel();
      }
      var CancelToken = axios.CancelToken;
      delete data.dashboard
      axios({
        method: "post",
        url: `${endPoint}`,
        data,
        cancelToken: new CancelToken((c) => {
          this.cancel = c;
        })
      })
        .then((response) => {
          if (response.data.response) resolve(response.data);
          else {
            {
              dispatch(
                "errorHandler",
                response.data.message || response.data.error
              );
              resolve(false);
            }
          }
        })
        .catch(function (er) {
          if (!axios.isCancel(er)) {
            dispatch("errorHandler", er.response);
            reject(er);
          }
        });
    });
  },

  searchCampaign({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      if (this.cancel !== undefined) {
        this.cancel();
      }
      var CancelToken = axios.CancelToken;
      axios({
        method: "post",
        url: `${APIUrl}/getCampaigns`,
        data,
        cancelToken: new CancelToken((c) => {
          this.cancel = c;
        })
      })
        .then((response) => {
          if (response.data.response) return resolve(response.data);
          else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            resolve(false);
          }
        })
        .catch(function (er) {
          if (!axios.isCancel(er)) {
            dispatch("errorHandler", er.response);
            reject(er);
          }
        });
    });
  },

  searchPerformance({ commit, dispatch }, data) {
    const { dashboard } = data;
    const endPoint = dashboard.endPoints.base + dashboard.endPoints.performance;
    delete data.dashboard
    return new Promise((resolve, reject) => {
      axios
        .post(`${endPoint}`, data)
        .then((response) => {
          if (response.data.response) {
            commit("setDashboarderStats", response.data);
            resolve(response.data);
          } else {
            {
              dispatch(
                "errorHandler",
                response.data.message || response.data.error
              );
              resolve(false);
            }
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
          reject(er);
        });
    });
  },

  searchReceiptStats({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${APIUrl}/receiptStatistics`, data)
        .then((response) => {
          if (response.data.response) {
            commit("setDashboarderStats", response.data);
            resolve(response.data);
          } else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            resolve(false);
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
          reject(er);
        });
    });
  },

  exportData({ dispatch }, data) {
    const { dashboard } = data;
    const endPoint = dashboard.endPoints.base + dashboard.endPoints.exportExcel;
    delete data.dashboard
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${endPoint}`,
        responseType: "blob",
        data
      })
        .then((response) => {
          if (response && response.data) resolve(response);
          else dispatch("errorHandler", "could not download file");
        })
        .catch((er) => {
          dispatch("errorHandler", er.message);
          reject(false);
        });
    });
  },

  snackAlert({ commit }, payload) {
    const { message, type = "error", duration = 1500 } = payload;
    commit("snackBar", { message, type, duration });
  },

  setDarkMode({ commit }, payload) {
    commit("setDarkMode", payload);
  },

  getLocationsList({ dispatch }, value) {
    const { dashboard, campaignId } = value;
    const endPoint = dashboard.endPoints.base + dashboard.endPoints.locations;
    return axios
      .get(`${endPoint}?campaignId=${campaignId || dashboard.campaignId}`)
      .then((response) => {
        if (response.data.response) {
          return response.data.result;
        } else {
          return {};
        }
      })
      .catch((er) => {
        dispatch("errorHandler", er.response);
      });
  },

  sendReceivedPackageReceipt({ dispatch, commit }, payload) {
    const { dashboard, status, data } = payload;
    const endPoint =
      dashboard.endPoints.base +
      dashboard.endPoints.receivedPackageReceipt[status];
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${endPoint}`,
        data: data
      })
        .then((response) => {
          if (response.data.response) return resolve(response.data);
          else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            reject(false);
          }
        })
        .catch((er) => {
          dispatch("errorHandler", er.response);
        })
        .finally(() => {
          setTimeout(() => commit("setReceiptPendingStatus", false), 250);
        });
    });
  },

  holdOn(_, payload) {
    return new Promise((resolve, reject) => {
      const { dashboard, campaignId } = payload;
      const base =
        campaignId &&
          dashboard.campaigns &&
          dashboard.campaigns[campaignId].hasSpecialBase
          ? dashboard.campaigns[campaignId].base
          : dashboard.endPoints.base;
      delete payload.dashboard
      axios
        .post(`${base}/holdOn`, payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((er) => {
          reject(er);
        });
    });
  },
  getBounceBackFilesList({ dispatch }, payload) {
    const { userToken } = payload;
    return axios
      .post(
        `https://js-backend.justsnap.eu/api/dashboard/getTransactionsList`,
        { userToken }
      )
      .then((response) => {
        return response.data;
      });
  },
  getBounceBackFile({ dispatch }, payload) {
    const { userToken } = payload;
    return axios
      .post(`https://js-backend.justsnap.eu/api/dashboard/getTransactions`, {
        path: payload.filename,
        userToken
      })
      .then((response) => {
        return response.data;
      });
  },
  getPendingCampaigns({ dispatch }, payload) {
    const { userToken, token } = payload;
    return axios
      .post(
        `https://js-backend.justsnap.eu/api/dashboard/getPendingCampaigns`,
        { endDate: payload.endDate, userToken, token }
      )
      .then((response) => {
        return response.data;
      });
  },
  getPendingCountries({ dispatch }, payload) {
    const { userToken, token } = payload;
    return axios
      .post(
        `https://js-backend.justsnap.eu/api/dashboard/getPendingCountries`,
        {
          endDate: payload.endDate,
          userToken,
          campaigns: payload.campaigns,
          token
        }
      )
      .then((response) => {
        return response.data;
      });
  },
  generatePendingList({ dispatch }, payload) {
    const { userToken, campaigns, endDate, countries, token } = payload;
    console.log(payload);
    return axios
      .post(`https://js-backend.justsnap.eu/api/dashboard/generateList`, {
        userToken,
        campaigns,
        endDate,
        countries,
        token
      })
      .then((response) => {
        return response.data;
      });
  },
  getCsvFileContent({ commit }, payload) {
    const { userToken, path, token } = payload;

    return axios
      .get(
        `https://js-backend.justsnap.eu/api/dashboard/getPaymentFile/${path.split(
          "https://js-payment-files.s3.eu-central-1.amazonaws.com/"
        )[1]
        }`,
        {
          headers: { userToken, token },
          onDownloadProgress: (progressEvent) => {
            const total = parseFloat(progressEvent.total);
            const current = progressEvent.loaded;

            let percentCompleted = Math.floor((current / total) * 100);
            commit("setPreviewProgress", percentCompleted);
            console.log("completed: ", progressEvent, percentCompleted);
          }
        }
      )
      .then((response) => {
        return response.data;
      });
  },
  paymentsLogin({ dispatch }, payload) {
    const { userToken, username, password, token } = payload;
    console.log(payload);
    return axios
      .post(`https://js-backend.justsnap.eu/api/dashboard/paymentsLogin`, {
        username,
        password,
        token
      })
      .then((response) => {
        return response.data;
      });
  },
  getPaymentFiles({ dispatch }, payload) {
    return axios
      .post(`https://js-backend.justsnap.eu/api/dashboard/getPaymentFiles`, {
        token: payload.token
      })
      .then((response) => {
        return response.data;
      });
  },
  s3ToTransactions({ dispatch }, payload) {
    const { path, token } = payload;
    console.log(path);
    return axios
      .post(`https://js-backend.justsnap.eu/api/dashboard/s3ToTransactions`, {
        file: path,
        token
      })
      .then((response) => {
        return response.data;
      });
  },
  getDeclinedPaymentReceipt({ getters, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `https://template-v2.justsnap.eu/api/dashboard/getOneReceiptPaymentDeclined`,
          { userToken: getters.userToken }
        )
        .then((response) => {
          if (response.data.response)
            resolve(response.data)
          else {
            reject(response.data.error)
            dispatch("errorHandler", response.data.error);
          }
        }).catch((er) => {
          dispatch("errorHandler", er.response.data.error);
          reject(er)
        })
    })
  },
  updatePaymentStatus({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`https://template-v2.justsnap.eu/api/dashboard/updatePaymentStatus`, payload)
        .then((response) => {
          if (response.data.response)
            resolve(response.data)
          else {
            dispatch("errorHandler", response.data.error);
            reject(response.data.error)
          }
        }).catch((er) => {
          dispatch("errorHandler", er.response.data.error);
          reject(er.response.data.error)
        })
    })
  },
  createAdditionalPayment({ state, dispatch }, value) {
    return new Promise((resolve, reject) => {
      console.log(value);
      const { dashboard, receiptToken, campaignId } = value;
      const endPoint = dashboard.endPoints.base + dashboard.endPoints.additionalPayment;
      const { userToken } = state;

      axios.post(`${endPoint}`, {
        receiptToken,
        userToken,
        campaignId
      })
        .then(response => {
          if (response.data.response) return resolve(response.data)
          else {
            dispatch('errorHandler', response.data.message || response.data.error);
            resolve(false)
          }
        })
        .catch(er => {
          dispatch('errorHandler', er.response.data);
          reject(er.response.data);
        })

    })
  },
  sendRaffleEmail({ commit }, data) {
    return new Promise((resolve, reject) => {
      const { dashboard } = data;
      const base = dashboard.endPoints.base
      const endPoint = base + '/sendRaffleEmail';
      delete data.dashboard;
      axios({
        method: "post",
        url: `${endPoint}`,
        data: data
      })
        .then((response) => {
          console.log("inside then in actions", response);
          if (response.data.error || response.data.response == false) {
            reject(response.data);
          }
          resolve(response.data);
        })
        .catch((er) => {
          reject(er.response.data);
        })
    });
  },
  changeStatusToFraud({ state, dispatch }, value) {
    return new Promise((resolve, reject) => {
      const { receiptToken, campaignId, dashboard, referenceNumber } = value;
      const endPoint = dashboard.endPoints.base + dashboard.endPoints.setToFraud;
      const { userToken } = state;

      axios.post(`${endPoint}`, {
        receiptToken,
        userToken,
        campaignId,
        referenceNumber
      })
        .then(response => {
          if (response.data.response) return resolve(response.data)
          else {
            dispatch('errorHandler', response.data.message || response.data.error);
            resolve(false)
          }
        })
        .catch(er => {
          dispatch('errorHandler', er.response.data);
          reject(er.response.data);
        })

    })
  },
  getFraudReceipts({ commit, dispatch }, value) {
    return new Promise((resolve, reject) => {
      const { userToken, dashboard } = value;
      const endPoint =
        dashboard.endPoints.base + dashboard.endPoints.getFraudReceipt;

      if (this.cancel) {
        this.cancel();
      }

      const CancelToken = axios.CancelToken;

      axios({
        method: "post",
        url: endPoint,
        data: { userToken },
        cancelToken: new CancelToken((c) => {
          this.cancel = c;
        })
      })
        .then((response) => {
          this.cancel = undefined;

          commit("clearCurrentReceipt");
          commit("setFraudRiskScore", "");
          commit("setFraudModelScore", "");
          commit("setFraudResult", "");
          commit("setProcessHistory", []);
          commit("setFraudModelWeights", {});

          if (response.data.response) {
            commit("setFraudRiskScore", response.data.receipt?.fraudRiskScore || "");
            commit(
              "setFraudModelScore",
              response.data.receipt?.fraudModelScore >= 0
                ? response.data.receipt?.fraudModelScore
                : ""
            );
            commit("setFraudResult", response.data.receipt?.fraudResult || "");
            commit("setProcessHistory", response.data.receipt?.processHistory || []);
            commit(
              "setFraudModelWeights",
              response.data.receipt?.fraudModelWeights || {}
            );
            resolve(response.data);
          } else {
            dispatch(
              "errorHandler",
              response.data.message || response.data.error
            );
            resolve(false);
          }
        })
        .catch((er) => {
          this.cancel = undefined;

          if (axios.isCancel(er)) {
            resolve(false);
            return;
          }

          dispatch("errorHandler", er.response || er);
          reject(er);
        });
    });
  },
  getMistakeReasons({ dispatch }, value) {
    return new Promise((resolve, reject) => {
      const { dashboard } = value;
      const endPoint = dashboard.endPoints.base
      axios.get(`${endPoint}/mistake-reasons?userToken=${value.userToken}`)
        .then(response => {
          if (response.data.response) resolve(response.data.reasons)
          else reject(response.data)
        }).catch(er => {
          dispatch('errorHandler', er.response)
          reject(er)
        });
    })
  },
  getAllDashboarders({ dispatch }, value) {
    return new Promise((resolve, reject) => {
      const { dashboard } = value;
      const endPoint = dashboard.endPoints.base
      axios.get(`${endPoint}/receipt-dashboarders?userToken=${value.userToken}&campaignId=${value.campaignId}&referenceNumber=${value.referenceNumber}`)
        .then(response => {
          if (response.data.response) resolve(response.data.dashboarders)
          else reject(response.data)
        }).catch(er => {
          dispatch('errorHandler', er.response)
          reject(er)
        });
    })
  },
  getSubmittedReports({ dispatch }, value) {
    return new Promise((resolve, reject) => {
      const { dashboard } = value;
      const endPoint = dashboard.endPoints.base
      axios.get(`${endPoint}/reports?userToken=${value.userToken}&campaignId=${value.campaignId}&dashboarderId=${value.dashboarderId}`)
        .then(response => {
          if (response.data.response) resolve(response.data.reports)
          else reject(response.data)
        }).catch(er => {
          dispatch('errorHandler', er.response)
          reject(er)
        });
    })
  },
  reportMistake({ dispatch }, value) {
    return new Promise((resolve, reject) => {
      const { dashboard } = value;
      const endPoint = dashboard.endPoints.base
      const payload = {
        dashboarderId: `${value.dashboarderId}`,
        campaignId: value.campaignId,
        referenceNumber: value.referenceNumber,
        reason: value.reason,
        description: value.description,
        userToken: value.userToken,
        receipt: value.receipt,
      }
      axios.post(`${endPoint}/report-mistake`, payload)
        .then(response => {
          if (response.data.response) resolve(response.data)
          else reject(response.data)
        }).catch(er => {
          dispatch('errorHandler', er.response)
          reject(er)
        });
    })
  },
  getUserInputs({ dispatch, getters }, value) {
    return new Promise((resolve, reject) => {
      const { dashboard } = value;
      const endPoint = dashboard.endPoints.base
      axios.get(`${endPoint}/dataFile/inputFields?userToken=${getters.userToken}`)
        .then(response => {
          if (response.data.response) resolve(response.data)
          else reject(response.data)
        }).catch(er => {
          dispatch('errorHandler', er.response)
          reject(er)
        });
    })
  },
  mistakeInputs({ dispatch, getters }, value) {
    return new Promise((resolve, reject) => {
      const { dashboard } = value;
      const endPoint = dashboard.endPoints.base
      axios.get(`${endPoint}/mistake-filters?userToken=${getters.userToken}`)
        .then(response => {
          if (response.data.response) resolve(response.data)
          else reject(response.data)
        }).catch(er => {
          dispatch('errorHandler', er.response)
          reject(er)
        });
    })
  },
  retrieveData({ dispatch, getters }, value) {
    return new Promise((resolve, reject) => {
      const { dashboard, data } = value;
      const endPoint = dashboard.endPoints.base
      data.userToken = getters.userToken
      axios.post(`${endPoint}/dataFile/data`, data)
        .then(response => {
          if (response.data.response) resolve(response.data)
          else reject(response.data)
        }).catch(er => {
          dispatch('errorHandler', er.response)
          reject(er)
        });
    })
  },
  downloadData({ dispatch, getters }, value) {
    return new Promise((resolve, reject) => {
      const { dashboard, data } = value;
      const endPoint = dashboard.endPoints.base
      data.userToken = getters.userToken
      axios.post(`${endPoint}/dataFile/downloadData`, data, { responseType: 'text' })
        .then(response => {
          if (response) resolve(response)
          else reject(response)
        }).catch(er => {
          dispatch('errorHandler', er.response)
          reject(er)
        });
    })
  },
  downloadMistakeReport({ dispatch, getters }, value) {
    return new Promise((resolve, reject) => {
      const { dashboard, data } = value;
      const endPoint = dashboard.endPoints.base
      data.userToken = getters.userToken
      axios.post(`${endPoint}/export-report`, data)
        .then(response => {
          if (response) resolve(response.data)
          else reject(response)
        }).catch(er => {
          dispatch('errorHandler', er.response)
          reject(er)
        });
    })
  },

  getHoldOnReceipts({ dispatch, getters }, payload) {
    return new Promise((resolve, reject) => {
      const { dashboard, data } = payload;
      const endPoint = dashboard.endPoints.base
      console.log(endPoint);
      axios
        .post(`${endPoint}/holdOnReceipts`, {
          userToken: payload.userToken
        })
        .then(response => {
          if (response.data.response) {
            resolve(response.data.receipts);
          } else {
            dispatch('errorHandler', response.data.error)
            reject(response.data.error);
          }
        })
        .catch(error => {
          console.error("Get hold on receipts error:", error);
          dispatch('errorHandler', error.response || error)
          reject(error);
        });
    });
  },

  holdToPreConfirm({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      const { dashboard, data } = payload;
      const endPoint = dashboard.endPoints.base
      axios
        .post(`${endPoint}/holdToPreConfirm`, {
          userToken: payload.userToken,
          receiptIds: payload.receiptIds
        })
        .then(response => {
          if (response.data.response) {
            resolve(response.data);
          } else {
            dispatch('errorHandler', response.data.error)
            reject(response.data.error);
          }
        })
        .catch(error => {
          console.error("Hold to pre-confirm error:", error);
          dispatch('errorHandler', error.response || error)
          reject(error);
        });
    });
  }
};
